import randomImg from '../Images/RandomButton.png';
import defaultImg from '../Images/Default.png';
import marioImg from "../Images/Mario.png";
import luigiImg from "../Images/Luigi.png";
import peachImg from "../Images/Peach.png";
import bowserImg from "../Images/Bowser.png";
import yoshiImg from "../Images/Yoshi.png";
import rosalinaImg from '../Images/Rosalina.png';
import bowserJrImg from '../Images/BowserJr.png';
import warioImg from '../Images/Wario.png';
import donkeyKongImg from '../Images/DonkeyKong.png';
import diddyKongImg from '../Images/DiddyKong.png';
import mrGameAndWatchImg from '../Images/MrGameAndWatch.png';
import littleMacImg from '../Images/LittleMac.png';
import linkImg from '../Images/Link.png';
import zeldaImg from '../Images/Zelda.png';
import sheikImg from '../Images/Sheik.png';
import ganondorfImg from '../Images/Ganondorf.png';
import toonLinkImg from '../Images/ToonLink.png';
import samusImg from '../Images/Samus.png';
import zssImg from '../Images/ZSS.png';
import pitImg from '../Images/Pit.png';
import palutenaImg from '../Images/Palutena.png';
import marthImg from '../Images/Marth.png';
import ikeImg from '../Images/Ike.png';
import tacticianImg from '../Images/Tactician.png';
import duckHuntImg from '../Images/DuckHunt.png';
import kirbyImg from '../Images/Kirby.png';
import kingDededeImg from '../Images/KingDedede.png';
import metaKnightImg from '../Images/MetaKnight.png';
import foxImg from '../Images/Fox.png';
import falcoImg from '../Images/Falco.png';
import pikachuImg from '../Images/Pikachu.png';
import charizardImg from '../Images/Charizard.png';
import lucarioImg from '../Images/Lucario.png';
import jigglypuffImg from '../Images/Jigglypuff.png';
import greninjaImg from '../Images/Greninja.png';
import robImg from '../Images/ROB.png';
import nessImg from '../Images/Ness.png';
import captainFalconImg from '../Images/CaptainFalcon.png';
import villagerImg from '../Images/Villager.png';
import olimarImg from '../Images/Olimar.png';
import wiiFitTrainerImg from '../Images/WiiFitTrainer.png';
import shulkImg from '../Images/Shulk.png';
import drMarioImg from '../Images/DrMario.png';
import darkPitImg from '../Images/DarkPit.png';
import lucinaImg from '../Images/Lucina.png';
import pacManImg from '../Images/PacMan.png';
import megaManImg from '../Images/MegaMan.png';
import sonicImg from '../Images/Sonic.png';
import mewTwoImg from '../Images/MewTwo.png';
import lucasImg from '../Images/Lucas.png';
import royImg from '../Images/Roy.png';
import ryuImg from '../Images/Ryu.png';
import cloudImg from '../Images/Cloud.png';
import corrinImg from '../Images/Corrin.png';
import bayonettaImg from '../Images/Bayonetta.png';
import qezoxImg from '../Images/Qezox.png';
import daciexImg from '../Images/Daciex.png';
import zeldarkImg from '../Images/Zeldark.png';

class Fighter {
  constructor(id, name, keyName, image, favor, specialChallenge, matchups) {
    this._id = id;
    this._name = name;
    this._keyName = keyName;
    this._image = image;
    this._playMetric = favor;
    this._favor = favor;
    this._rollingFavor = favor;
    this._matchups = matchups;
    this._specialChallenge = specialChallenge;
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get keyName() {
    return this._keyName;
  }

  get image() {
    return this._image;
  }

  get playMetric() {
    return this._playMetric;
  }

  updatePlayMetric(opponentKeyName, mode) {
    if (opponentKeyName !== "defaultOpponent") {
      if (mode === "favoredRandom") {
        this._playMetric = this.rollingFavor;
      } else if (mode === "counteredRandom") {
        this._playMetric = this.matchups[opponentKeyName];
      } else if (mode === "specialistRandom") {
        this._playMetric = this.rollingFavor * this.matchups[opponentKeyName];
      }
    } else {
      this._playMetric = this.rollingFavor;
      Roster.djangoMetrics[this.keyName] = this.rollingFavor
    }
  }

  get favor() {
    return this._favor;
  }

  loadFavor(value) {
    this._rollingFavor = value;
  }

  get rollingFavor() {
    return this._rollingFavor;
  }

  favorUp() {
    let bonusFavor = (Math.floor(Math.random() * this.favor * 10))/10;
    this._rollingFavor += this.favor + Math.floor(Math.random() + bonusFavor);
  }

  resetFavor() {
    this._rollingFavor = this.favor;
  }

  get matchups() {
    return this._matchups;
  }

  get specialChallenge() {
    return this._specialChallenge;
  }
}

const mario = new Fighter(0, "Mario", "mario", marioImg, 10, "Water Cannon", {
  qezox: 6,
  daciex: 6.6,
  zeldark: 5.5,
  defaultOpponent: null,
  mario: 5.0,
  jigglypuff: 6.9,
  bowserJr: 6.6,
  ganondorf: 6.6,
  wiiFitTrainer: 6.5,
  littleMac: 6.5,
  zelda: 6.5,
  duckHunt: 6.3,
  kingDedede: 6.2,
  charizard: 6.2,
  falco: 6.2,
  tactician: 6.2,
  samus: 6.2,
  palutena: 6.1,
  pacMan: 6.0,
  pikachu: 6.0,
  ike: 6.0,
  rob: 6.0,
  megaMan: 5.9,
  link: 5.9,
  wario: 5.8,
  ness: 5.8,
  olimar: 5.8,
  kirby: 5.7,
  mrGameAndWatch: 5.7,
  captainFalcon: 5.7,
  villager: 5.7,
  roy: 5.7,
  drMario: 5.6,
  lucas: 5.6,
  toonLink: 5.6,
  metaKnight: 5.5,
  bowser: 5.5,
  shulk: 5.5,
  pit: 5.5,
  darkPit: 5.5,
  lucario: 5.5,
  peach: 5.4,
  greninja: 5.4,
  fox: 5.2,
  donkeyKong: 5.2,
  mewTwo: 5.1,
  luigi: 5.1,
  yoshi: 5.1,
  corrin: 5.1,
  bayonetta: 5.0,
  zss: 5.0,
  diddyKong: 4.9,
  lucina: 4.9,
  ryu: 4.9,
  sheik: 4.8,
  marth: 4.7,
  cloud: 4.6,
  sonic: 4.6,
  rosalina: 4.5
});
const luigi = new Fighter(1, "Luigi", "luigi", luigiImg, 10, "Up B", {
  defaultOpponent: null,
  qezox: 6,
  daciex: 6,
  zeldark: 5,
  luigi: 5,
  zelda: 6.2,
  falco: 6.2,
  jigglypuff: 6.1,
  ganondorf: 6.1,
  palutena: 6.0,
  kirby: 6.0,
  bowserJr: 6.0,
  charizard: 5.7,
  littleMac: 5.7,
  pacMan: 5.7,
  kingDedede: 5.6,
  drMario: 5.6,
  roy: 5.5,
  donkeyKong: 5.4,
  ike: 5.4,
  captainFalcon: 5.4,
  wiiFitTrainer: 5.3,
  duckHunt: 5.3,
  mrGameAndWatch: 5.3,
  rob: 5.2,
  samus: 5.2,
  peach: 5.2,
  link: 5.2,
  bowser: 5.2,
  wario: 5.1,
  pit: 5.1,
  fox: 5.1,
  ness: 5.0,
  greninja: 5.0,
  darkPit: 4.9,
  mario: 4.9,
  pikachu: 4.9,
  lucas: 4.9,
  olimar: 4.8,
  toonLink: 4.8,
  shulk: 4.8,
  diddyKong: 4.7,
  lucina: 4.7,
  metaKnight: 4.7,
  tactician: 4.7,
  yoshi: 4.7,
  villager: 4.6,
  ryu: 4.6,
  sheik: 4.4,
  corrin: 4.3,
  zss: 4.3,
  lucario: 4.2,
  cloud: 4.2,
  sonic: 4.2,
  megaMan: 4.1,
  marth: 4.1,
  bayonetta: 4.0,
  mewTwo: 4.0,
  rosalina: 3.8
});
const peach = new Fighter(2, "Peach", "peach", peachImg, 8, "Turnip Stage Spike", {
  defaultOpponent: null,
  peach: 5.0,
  qezox: 4.5,
  daciex: 5,
  zeldark: 4,
  zelda: 6.2,
  jigglypuff: 6.1,
  bowserJr: 6.0,
  littleMac: 6.0,
  ganondorf: 6.0,
  mrGameAndWatch: 5.9,
  wiiFitTrainer: 5.9,
  palutena: 5.8,
  kingDedede: 5.8,
  charizard: 5.6,
  duckHunt: 5.5,
  pacMan: 5.5,
  drMario: 5.5,
  kirby: 5.4,
  wario: 5.4,
  shulk: 5.3,
  bowser: 5.3,
  samus: 5.2,
  falco: 5.2,
  link: 5.2,
  donkeyKong: 5.2,
  ike: 5.1,
  roy: 5.1,
  lucas: 5.0,
  rob: 4.9,
  tactician: 4.9,
  pit: 4.9,
  darkPit: 4.8,
  luigi: 4.8,
  greninja: 4.8,
  captainFalcon: 4.7,
  ness: 4.7,
  megaMan: 4.7,
  corrin: 4.7,
  villager: 4.7,
  lucina: 4.7,
  toonLink: 4.6,
  mario: 4.6,
  marth: 4.6,
  mewTwo: 4.6,
  rosalina: 4.6,
  yoshi: 4.5,
  olimar: 4.5,
  fox: 4.5,
  pikachu: 4.4,
  sheik: 4.4,
  lucario: 4.4,
  ryu: 4.3,
  bayonetta: 4.2,
  zss: 4.2,
  diddyKong: 4.1,
  cloud: 4.0,
  sonic: 3.9,
  metaKnight: 3.9
});
const bowser = new Fighter(3, "Bowser", "bowser", bowserImg, 5, "Side-B Death", {
  defaultOpponent: null,
  bowser: 5.0,
  qezox: 3.5,
  daciex: 6,
  zeldark: 3.5,
  jigglypuff: 6.3,
  drMario: 6.0,
  mrGameAndWatch: 6.0,
  zelda: 5.9,
  roy: 5.8,
  kingDedede: 5.8,
  ganondorf: 5.8,
  shulk: 5.8,
  bowserJr: 5.7,
  ike: 5.7,
  palutena: 5.7,
  falco: 5.7,
  charizard: 5.7,
  wiiFitTrainer: 5.7,
  samus: 5.6,
  kirby: 5.5,
  link: 5.5,
  wario: 5.4,
  donkeyKong: 5.3,
  littleMac: 5.2,
  pacMan: 5.2,
  duckHunt: 5.2,
  lucario: 5.2,
  olimar: 5.2,
  pit: 5.0,
  lucina: 5.0,
  tactician: 4.9,
  darkPit: 4.8,
  luigi: 4.8,
  lucas: 4.8,
  peach: 4.7,
  greninja: 4.6,
  ness: 4.5,
  marth: 4.5,
  mario: 4.5,
  rob: 4.4,
  captainFalcon: 4.3,
  yoshi: 4.2,
  megaMan: 4.2,
  mewTwo: 4.2,
  toonLink: 4.2,
  fox: 4.1,
  corrin: 4.1,
  metaKnight: 4.0,
  diddyKong: 3.9,
  pikachu: 3.9,
  villager: 3.9,
  ryu: 3.9,
  cloud: 3.9,
  sheik: 3.7,
  bayonetta: 3.6,
  sonic: 3.5,
  rosalina: 3.4,
  zss: 3.1
});
const yoshi = new Fighter(4, "Yoshi", "yoshi", yoshiImg, 10, "Forward-Air Sike", {
  defaultOpponent: null,
  yoshi: 5.0,
  qezox: 6,
  daciex: 6.5,
  zeldark: 5,
  jigglypuff: 6.5,
  ganondorf: 6.3,
  zelda: 6.2,
  littleMac: 6.0,
  donkeyKong: 5.9,
  mrGameAndWatch: 5.8,
  bowserJr: 5.8,
  palutena: 5.8,
  falco: 5.8,
  bowser: 5.8,
  drMario: 5.7,
  kingDedede: 5.7,
  pacMan: 5.6,
  charizard: 5.5,
  duckHunt: 5.5,
  kirby: 5.5,
  samus: 5.5,
  peach: 5.5,
  wario: 5.4,
  luigi: 5.3,
  tactician: 5.3,
  link: 5.3,
  wiiFitTrainer: 5.3,
  ness: 5.3,
  shulk: 5.3,
  lucas: 5.3,
  darkPit: 5.3,
  rob: 5.2,
  toonLink: 5.2,
  roy: 5.2,
  ike: 5.1,
  villager: 5.0,
  fox: 5.0,
  greninja: 5.0,
  captainFalcon: 4.9,
  lucario: 4.9,
  mario: 4.9,
  lucina: 4.9,
  pit: 4.9,
  pikachu: 4.9,
  olimar: 4.8,
  marth: 4.7,
  mewTwo: 4.7,
  ryu: 4.7,
  megaMan: 4.7,
  metaKnight: 4.5,
  corrin: 4.5,
  zss: 4.4,
  sonic: 4.4,
  diddyKong: 4.3,
  sheik: 4.3,
  rosalina: 4.2,
  cloud: 4.0,
  bayonetta: 3.8
});
const rosalina = new Fighter(5, "Rosalina", "rosalina", rosalinaImg, 6, "Independent Luma KO", {
  defaultOpponent: null,
  rosalina: 5.0,
  qezox: 6.5,
  daciex: 6,
  zeldark: 5.5,
  ness: 7.2,
  bowserJr: 6.9,
  ganondorf: 6.9,
  littleMac: 6.7,
  jigglypuff: 6.7,
  kingDedede: 6.6,
  donkeyKong: 6.6,
  charizard: 6.6,
  bowser: 6.6,
  zelda: 6.5,
  drMario: 6.4,
  pacMan: 6.4,
  roy: 6.4,
  mrGameAndWatch: 6.4,
  duckHunt: 6.3,
  link: 6.3,
  rob: 6.3,
  falco: 6.3,
  kirby: 6.3,
  luigi: 6.2,
  samus: 6.2,
  wiiFitTrainer: 6.1,
  ike: 6.1,
  palutena: 6.1,
  wario: 6.0,
  villager: 6.0,
  tactician: 6.0,
  megaMan: 6.0,
  greninja: 5.9,
  lucas: 5.8,
  marth: 5.8,
  yoshi: 5.8,
  olimar: 5.8,
  captainFalcon: 5.7,
  lucina: 5.7,
  shulk: 5.6,
  darkPit: 5.6,
  toonLink: 5.6,
  pit: 5.5,
  lucario: 5.5,
  mario: 5.5,
  peach: 5.4,
  ryu: 5.3,
  fox: 5.2,
  pikachu: 5.2,
  diddyKong: 5.1,
  sheik: 5.0,
  sonic: 4.9,
  mewTwo: 4.8,
  corrin: 4.8,
  zss: 4.8,
  bayonetta: 4.7,
  cloud: 4.6,
  metaKnight: 4.0
});
const bowserJr = new Fighter(6, "Bowser Jr", "bowserJr", bowserJrImg, 4, "Up B Combo?", {
  defaultOpponent: null,
  qezox: 3.5,
  daciex: 5,
  zeldark: 4,
  mrGameAndWatch: 5.5,
  ganondorf: 5.2,
  jigglypuff: 5.2,
  kingDedede: 5.2,
  bowserJr: 5.0,
  wiiFitTrainer: 5.0,
  zelda: 5.0,
  pacMan: 5.0,
  littleMac: 4.9,
  drMario: 4.9,
  falco: 4.8,
  samus: 4.7,
  duckHunt: 4.7,
  donkeyKong: 4.7,
  kirby: 4.7,
  palutena: 4.6,
  darkPit: 4.5,
  wario: 4.5,
  shulk: 4.5,
  charizard: 4.3,
  toonLink: 4.3,
  pit: 4.3,
  bowser: 4.3,
  ike: 4.3,
  megaMan: 4.2,
  link: 4.2,
  yoshi: 4.2,
  olimar: 4.2,
  tactician: 4.2,
  lucina: 4.2,
  roy: 4.1,
  lucas: 4.1,
  corrin: 4.1,
  luigi: 4.0,
  greninja: 4.0,
  metaKnight: 4.0,
  ryu: 4.0,
  sonic: 4.0,
  peach: 4.0,
  rob: 3.9,
  pikachu: 3.9,
  captainFalcon: 3.9,
  lucario: 3.9,
  marth: 3.9,
  ness: 3.9,
  diddyKong: 3.7,
  sheik: 3.7,
  fox: 3.7,
  cloud: 3.6,
  mewTwo: 3.5,
  zss: 3.5,
  villager: 3.4,
  mario: 3.4,
  bayonetta: 3.2,
  rosalina: 3.1
});
const wario = new Fighter(7, "Wario", "wario", warioImg, 4, "Fart KO", {
  defaultOpponent: null,
  wario: 5.0,
  qezox: 4,
  daciex: 4.5,
  zeldark: 4,
  jigglypuff: 6.1,
  zelda: 5.6,
  pacMan: 5.6,
  wiiFitTrainer: 5.5,
  drMario: 5.5,
  bowserJr: 5.5,
  palutena: 5.4,
  kingDedede: 5.4,
  lucario: 5.4,
  duckHunt: 5.3,
  littleMac: 5.3,
  kirby: 5.2,
  falco: 5.1,
  charizard: 5.1,
  ganondorf: 5.1,
  mrGameAndWatch: 5.0,
  samus: 5.0,
  lucas: 4.9,
  roy: 4.9,
  darkPit: 4.9,
  luigi: 4.9,
  ike: 4.8,
  pit: 4.7,
  olimar: 4.7,
  donkeyKong: 4.7,
  peach: 4.6,
  captainFalcon: 4.6,
  yoshi: 4.6,
  link: 4.6,
  ness: 4.6,
  shulk: 4.6,
  megaMan: 4.6,
  bowser: 4.6,
  lucina: 4.5,
  metaKnight: 4.4,
  greninja: 4.4,
  tactician: 4.4,
  rob: 4.4,
  ryu: 4.4,
  toonLink: 4.3,
  sonic: 4.3,
  mewTwo: 4.3,
  pikachu: 4.2,
  sheik: 4.2,
  mario: 4.2,
  villager: 4.1,
  fox: 4.1,
  marth: 4.1,
  corrin: 4.0,
  rosalina: 4.0,
  zss: 3.9,
  diddyKong: 3.8,
  cloud: 3.7,
  bayonetta: 3.6
});
const donkeyKong = new Fighter(8, "Donkey Kong", "donkeyKong", donkeyKongImg, 5, "Super Punch", {
  defaultOpponent: null,
  donkeyKong: 5.0,
  qezox: 3.5,
  daciex: 6,
  zeldark: 4.5,
  jigglypuff: 6.4,
  drMario: 6.2,
  ganondorf: 6.1,
  zelda: 6.0,
  kirby: 5.8,
  mrGameAndWatch: 5.7,
  falco: 5.6,
  littleMac: 5.6,
  kingDedede: 5.5,
  roy: 5.5,
  lucario: 5.5,
  shulk: 5.5,
  lucina: 5.4,
  duckHunt: 5.4,
  ike: 5.4,
  wiiFitTrainer: 5.4,
  charizard: 5.4,
  palutena: 5.4,
  wario: 5.3,
  bowserJr: 5.3,
  link: 5.3,
  samus: 5.3,
  darkPit: 5.1,
  pit: 5.0,
  pacMan: 4.9,
  lucas: 4.9,
  peach: 4.8,
  mario: 4.8,
  bowser: 4.7,
  marth: 4.6,
  ness: 4.6,
  luigi: 4.6,
  greninja: 4.5,
  sheik: 4.4,
  captainFalcon: 4.4,
  mewTwo: 4.4,
  tactician: 4.2,
  toonLink: 4.2,
  rob: 4.2,
  fox: 4.2,
  olimar: 4.1,
  corrin: 4.1,
  metaKnight: 4.1,
  diddyKong: 4.1,
  yoshi: 4.1,
  villager: 4.1,
  ryu: 4.0,
  pikachu: 4.0,
  cloud: 4.0,
  megaMan: 3.9,
  bayonetta: 3.8,
  sonic: 3.7,
  rosalina: 3.4,
  zss: 3.4
});
const diddyKong = new Fighter(9, "Diddy Kong", "diddyKong", diddyKongImg, 5, "Banana Gimp", {
  defaultOpponent: null,
  diddyKong: 5.0,
  qezox: 6,
  daciex: 6.5,
  zeldark: 5.5,
  kingDedede: 7.0,
  ganondorf: 6.9,
  jigglypuff: 6.9,
  zelda: 6.6,
  charizard: 6.6,
  shulk: 6.4,
  palutena: 6.4,
  ike: 6.4,
  roy: 6.3,
  drMario: 6.3,
  bowserJr: 6.3,
  falco: 6.2,
  kirby: 6.2,
  wario: 6.2,
  link: 6.2,
  mrGameAndWatch: 6.2,
  littleMac: 6.2,
  samus: 6.2,
  bowser: 6.1,
  tactician: 6.1,
  wiiFitTrainer: 6.1,
  pacMan: 6.0,
  duckHunt: 6.0,
  rob: 6.0,
  captainFalcon: 5.9,
  zss: 5.9,
  donkeyKong: 5.9,
  peach: 5.9,
  ness: 5.9,
  marth: 5.8,
  lucas: 5.8,
  metaKnight: 5.8,
  lucina: 5.7,
  greninja: 5.7,
  darkPit: 5.7,
  yoshi: 5.7,
  pit: 5.6,
  mewTwo: 5.6,
  lucario: 5.6,
  ryu: 5.5,
  corrin: 5.5,
  toonLink: 5.4,
  villager: 5.4,
  pikachu: 5.3,
  bayonetta: 5.3,
  sheik: 5.3,
  luigi: 5.3,
  sonic: 5.2,
  cloud: 5.2,
  fox: 5.2,
  olimar: 5.2,
  mario: 5.1,
  megaMan: 5.0,
  rosalina: 4.9
});
const mrGameAndWatch = new Fighter(10, "Mr Game & Watch", "mrGameAndWatch", mrGameAndWatchImg, 5, "9", {
  defaultOpponent: null,
  mrGameAndWatch: 5.0,
  qezox: 6,
  daciex: 6,
  zeldark: 4.5,
  samus: 5.9,
  zelda: 5.7,
  jigglypuff: 5.6,
  duckHunt: 5.4,
  palutena: 5.3,
  pikachu: 5.2,
  wiiFitTrainer: 5.2,
  link: 5.2,
  ness: 5.1,
  shulk: 5.0,
  lucario: 5.0,
  charizard: 5.0,
  wario: 5.0,
  ganondorf: 5.0,
  kirby: 4.9,
  tactician: 4.9,
  falco: 4.9,
  lucas: 4.9,
  kingDedede: 4.8,
  littleMac: 4.8,
  roy: 4.8,
  luigi: 4.7,
  drMario: 4.7,
  rob: 4.7,
  toonLink: 4.7,
  pacMan: 4.6,
  pit: 4.6,
  bowserJr: 4.5,
  villager: 4.5,
  ike: 4.5,
  darkPit: 4.5,
  olimar: 4.4,
  donkeyKong: 4.3,
  mario: 4.3,
  lucina: 4.3,
  greninja: 4.2,
  corrin: 4.2,
  megaMan: 4.2,
  yoshi: 4.2,
  peach: 4.1,
  mewTwo: 4.1,
  sheik: 4.1,
  captainFalcon: 4.0,
  bowser: 4.0,
  marth: 4.0,
  ryu: 3.9,
  zss: 3.9,
  fox: 3.8,
  diddyKong: 3.8,
  metaKnight: 3.8,
  cloud: 3.8,
  sonic: 3.7,
  rosalina: 3.6,
  bayonetta: 3.6
});
const littleMac = new Fighter(11, "Little Mac", "littleMac", littleMacImg, 5, "KO Punch", {
  defaultOpponent: null,
  littleMac: 5.0,
  qezox: 4,
  daciex: 6,
  zeldark: 4.5,
  zelda: 6.1,
  charizard: 5.5,
  ganondorf: 5.4,
  drMario: 5.4,
  palutena: 5.3,
  mrGameAndWatch: 5.2,
  wiiFitTrainer: 5.1,
  bowserJr: 5.1,
  duckHunt: 5.1,
  falco: 4.9,
  samus: 4.8,
  bowser: 4.8,
  jigglypuff: 4.7,
  olimar: 4.7,
  shulk: 4.7,
  roy: 4.7,
  wario: 4.7,
  pacMan: 4.6,
  lucario: 4.6,
  mewTwo: 4.5,
  link: 4.5,
  kingDedede: 4.5,
  donkeyKong: 4.4,
  ike: 4.4,
  megaMan: 4.4,
  kirby: 4.4,
  tactician: 4.3,
  captainFalcon: 4.3,
  luigi: 4.3,
  fox: 4.2,
  lucina: 4.2,
  pit: 4.1,
  darkPit: 4.0,
  toonLink: 4.0,
  ryu: 4.0,
  yoshi: 4.0,
  rob: 4.0,
  lucas: 4.0,
  peach: 4.0,
  marth: 3.9,
  villager: 3.9,
  sonic: 3.9,
  corrin: 3.9,
  metaKnight: 3.9,
  greninja: 3.9,
  diddyKong: 3.8,
  ness: 3.8,
  zss: 3.7,
  mario: 3.5,
  pikachu: 3.4,
  bayonetta: 3.3,
  rosalina: 3.3,
  sheik: 3.3,
  cloud: 3.1
});
const link = new Fighter(12, "Link", "link", linkImg, 10, "Up-Special", {
  defaultOpponent: null,
  link: 5,
  qezox: 5,
  daciex: 6,
  zeldark: 5,
  ganondorf: 6.3,
  kingDedede: 6.2,
  jigglypuff: 6.1,
  zelda: 5.9,
  bowserJr: 5.8,
  kirby: 5.7,
  duckHunt: 5.6,
  pacMan: 5.6,
  littleMac: 5.5,
  wario: 5.4,
  wiiFitTrainer: 5.3,
  falco: 5.2,
  shulk: 5.1,
  palutena: 5.1,
  samus: 5.0,
  drMario: 5.0,
  charizard: 4.9,
  ike: 4.9,
  roy: 4.8,
  rob: 4.8,
  luigi: 4.8,
  peach: 4.8,
  mrGameAndWatch: 4.8,
  lucas: 4.8,
  pit: 4.7,
  tactician: 4.7,
  donkeyKong: 4.7,
  yoshi: 4.7,
  ness: 4.7,
  megaMan: 4.6,
  toonLink: 4.6,
  lucina: 4.5,
  bowser: 4.5,
  corrin: 4.5,
  greninja: 4.5,
  villager: 4.5,
  darkPit: 4.2,
  captainFalcon: 4.1,
  mario: 4.1,
  olimar: 4.1,
  marth: 4.1,
  ryu: 4.1,
  mewTwo: 4.1,
  pikachu: 4.0,
  cloud: 4.0,
  lucario: 3.9,
  sonic: 3.8,
  metaKnight: 3.8,
  diddyKong: 3.8,
  rosalina: 3.7,
  zss: 3.7,
  fox: 3.6,
  bayonetta: 3.5,
  sheik: 3.5
});
const zelda = new Fighter(13, "Zelda", "zelda", zeldaImg, 10, "Teleport KO", {
  defaultOpponent: null,
  zelda: 5.0,
  qezox: 5.0,
  daciex: 5.0,
  zeldark: 4.5,
  ganondorf: 5.4,
  kingDedede: 5.3,
  jigglypuff: 5.3,
  wiiFitTrainer: 5.0,
  bowserJr: 5.0,
  pacMan: 5.0,
  samus: 4.5,
  roy: 4.5,
  falco: 4.4,
  lucas: 4.4,
  duckHunt: 4.4,
  charizard: 4.4,
  wario: 4.4,
  tactician: 4.3,
  drMario: 4.3,
  mrGameAndWatch: 4.3,
  palutena: 4.2,
  pit: 4.2,
  bowser: 4.1,
  rob: 4.1,
  shulk: 4.1,
  link: 4.1,
  greninja: 4.1,
  ike: 4.0,
  darkPit: 4.0,
  toonLink: 4.0,
  kirby: 4.0,
  donkeyKong: 4.0,
  villager: 4.0,
  megaMan: 4.0,
  littleMac: 3.9,
  lucina: 3.8,
  yoshi: 3.8,
  peach: 3.8,
  olimar: 3.8,
  ness: 3.8,
  luigi: 3.8,
  lucario: 3.7,
  marth: 3.7,
  mewTwo: 3.6,
  pikachu: 3.6,
  mario: 3.5,
  corrin: 3.5,
  fox: 3.5,
  rosalina: 3.5,
  captainFalcon: 3.4,
  ryu: 3.4,
  diddyKong: 3.4,
  metaKnight: 3.3,
  zss: 3.3,
  sonic: 3.2,
  cloud: 3.1,
  sheik: 3.0,
  bayonetta: 3.0
});
const sheik = new Fighter(14, "Sheik", "sheik", sheikImg, 4, "Floppy Fish Gimp", {
  defaultOpponent: null,
  sheik: 5.0,
  qezox: 6,
  daciex: 5.5,
  zeldark: 5,
  ganondorf: 7.2,
  zelda: 7.0,
  kingDedede: 7.0,
  littleMac: 6.7,
  ike: 6.7,
  palutena: 6.6,
  link: 6.5,
  jigglypuff: 6.5,
  captainFalcon: 6.4,
  samus: 6.3,
  bowserJr: 6.3,
  wiiFitTrainer: 6.3,
  roy: 6.3,
  bowser: 6.3,
  duckHunt: 6.2,
  charizard: 6.2,
  tactician: 6.2,
  ness: 6.2,
  shulk: 6.1,
  drMario: 6.1,
  falco: 6.0,
  mrGameAndWatch: 5.9,
  rob: 5.9,
  lucas: 5.9,
  megaMan: 5.8,
  wario: 5.8,
  greninja: 5.8,
  pacMan: 5.7,
  zss: 5.7,
  yoshi: 5.7,
  pit: 5.7,
  olimar: 5.7,
  darkPit: 5.7,
  villager: 5.7,
  luigi: 5.6,
  toonLink: 5.6,
  peach: 5.6,
  donkeyKong: 5.6,
  kirby: 5.6,
  bayonetta: 5.5,
  lucina: 5.5,
  corrin: 5.5,
  cloud: 5.5,
  metaKnight: 5.4,
  pikachu: 5.3,
  mewTwo: 5.3,
  marth: 5.3,
  lucario: 5.2,
  fox: 5.2,
  ryu: 5.2,
  mario: 5.2,
  sonic: 5.0,
  rosalina: 5.0,
  diddyKong: 4.7
});
const ganondorf= new Fighter(15, "Ganondorf", "ganondorf", ganondorfImg, 7, "Ganoncide", {
  defaultOpponent: null,
  ganondorf: 5.0,
  qezox: 4,
  daciex: 5,
  zeldark: 4.5,
  jigglypuff: 5.4,
  drMario: 5.3,
  mrGameAndWatch: 5.0,
  wario: 4.9,
  kingDedede: 4.8,
  bowserJr: 4.8,
  charizard: 4.7,
  palutena: 4.7,
  zelda: 4.6,
  littleMac: 4.6,
  wiiFitTrainer: 4.5,
  kirby: 4.5,
  roy: 4.4,
  falco: 4.3,
  duckHunt: 4.3,
  olimar: 4.2,
  darkPit: 4.2,
  bowser: 4.2,
  lucario: 4.2,
  samus: 4.2,
  pacMan: 4.1,
  shulk: 4.1,
  ike: 4.1,
  tactician: 4.1,
  pit: 4.0,
  peach: 4.0,
  lucas: 4.0,
  mewTwo: 3.9,
  luigi: 3.9,
  donkeyKong: 3.9,
  metaKnight: 3.8,
  lucina: 3.8,
  link: 3.7,
  yoshi: 3.7,
  rob: 3.7,
  ness: 3.7,
  megaMan: 3.7,
  corrin: 3.6,
  fox: 3.6,
  greninja: 3.5,
  marth: 3.5,
  captainFalcon: 3.5,
  villager: 3.4,
  mario: 3.4,
  pikachu: 3.3,
  ryu: 3.3,
  toonLink: 3.2,
  rosalina: 3.1,
  diddyKong: 3.1,
  cloud: 3.0,
  zss: 3.0,
  sonic: 2.9,
  sheik: 2.8,
  bayonetta: 2.4
});
const toonLink= new Fighter(16, "Toon Link", "toonLink", toonLinkImg, 5, "Down-Air KO", {
  defaultOpponent: null,
  toonLink: 5.0,
  qezox: 5.0,
  daciex: 6,
  zeldark: 5,
  jigglypuff: 6.8,
  ganondorf: 6.8,
  kingDedede: 6.2,
  zelda: 6.0,
  littleMac: 6.0,
  kirby: 5.9,
  palutena: 5.9,
  tactician: 5.9,
  duckHunt: 5.9,
  bowser: 5.8,
  charizard: 5.8,
  donkeyKong: 5.8,
  drMario: 5.8,
  olimar: 5.7,
  wario: 5.7,
  bowserJr: 5.7,
  wiiFitTrainer: 5.6,
  pacMan: 5.6,
  samus: 5.5,
  ike: 5.4,
  link: 5.4,
  peach: 5.4,
  rob: 5.4,
  mrGameAndWatch: 5.3,
  roy: 5.3,
  falco: 5.2,
  luigi: 5.2,
  shulk: 5.2,
  ness: 5.1,
  captainFalcon: 5.1,
  lucas: 5.0,
  darkPit: 5.0,
  pit: 4.9,
  lucina: 4.9,
  corrin: 4.9,
  ryu: 4.8,
  yoshi: 4.8,
  marth: 4.7,
  bayonetta: 4.7,
  villager: 4.7,
  megaMan: 4.6,
  greninja: 4.6,
  zss: 4.6,
  metaKnight: 4.6,
  diddyKong: 4.6,
  sonic: 4.5,
  lucario: 4.4,
  mario: 4.4,
  rosalina: 4.4,
  mewTwo: 4.4,
  sheik: 4.4,
  pikachu: 4.3,
  fox: 4.2,
  cloud: 4.1
});
const samus = new Fighter(17, "Samus", "samus", samusImg, 5, "Charged Shot KO", {
  defaultOpponent: null,
  samus: 5.0,
  qezox: 4,
  daciex: 6,
  zeldark: 5,
  kingDedede: 6.0,
  jigglypuff: 5.9,
  ganondorf: 5.8,
  kirby: 5.7,
  pacMan: 5.6,
  zelda: 5.5,
  bowserJr: 5.3,
  wiiFitTrainer: 5.2,
  littleMac: 5.2,
  roy: 5.1,
  shulk: 5.0,
  wario: 5.0,
  link: 5.0,
  charizard: 4.9,
  peach: 4.8,
  luigi: 4.8,
  ike: 4.8,
  lucina: 4.7,
  donkeyKong: 4.7,
  tactician: 4.7,
  falco: 4.7,
  palutena: 4.6,
  ryu: 4.6,
  greninja: 4.6,
  rob: 4.6,
  pit: 4.6,
  drMario: 4.5,
  toonLink: 4.5,
  yoshi: 4.5,
  megaMan: 4.5,
  darkPit: 4.4,
  bowser: 4.4,
  duckHunt: 4.3,
  captainFalcon: 4.3,
  lucas: 4.3,
  marth: 4.3,
  corrin: 4.2,
  zss: 4.1,
  mrGameAndWatch: 4.1,
  metaKnight: 4.0,
  sonic: 4.0,
  cloud: 4.0,
  lucario: 4.0,
  mewTwo: 3.9,
  villager: 3.9,
  olimar: 3.9,
  ness: 3.9,
  mario: 3.8,
  rosalina: 3.8,
  diddyKong: 3.8,
  sheik: 3.7,
  bayonetta: 3.6,
  pikachu: 3.6,
  fox: 3.2
});
const zss = new Fighter(18, "Zero Suit Samus", "zss", zssImg, 10, "Stun Down-B Combo", {
  defaultOpponent: null,
  zss: 5.0,
  qezox: 6.5,
  daciex: 6,
  zeldark: 5,
  kingDedede: 7.1,
  charizard: 7.1,
  ganondorf: 7.0,
  bowser: 6.9,
  zelda: 6.7,
  palutena: 6.6,
  donkeyKong: 6.6,
  bowserJr: 6.5,
  jigglypuff: 6.4,
  link: 6.3,
  littleMac: 6.3,
  wiiFitTrainer: 6.3,
  tactician: 6.3,
  duckHunt: 6.2,
  drMario: 6.2,
  rob: 6.2,
  wario: 6.2,
  shulk: 6.1,
  roy: 6.1,
  mrGameAndWatch: 6.1,
  ike: 6.0,
  falco: 6.0,
  samus: 5.9,
  lucina: 5.8,
  pacMan: 5.8,
  peach: 5.8,
  kirby: 5.8,
  captainFalcon: 5.8,
  luigi: 5.7,
  ness: 5.6,
  darkPit: 5.6,
  yoshi: 5.6,
  pit: 5.6,
  lucario: 5.5,
  megaMan: 5.5,
  lucas: 5.5,
  villager: 5.4,
  toonLink: 5.4,
  metaKnight: 5.3,
  corrin: 5.3,
  greninja: 5.3,
  rosalina: 5.2,
  marth: 5.1,
  mewTwo: 5.1,
  olimar: 5.1,
  mario: 5.0,
  sonic: 5.0,
  ryu: 4.9,
  fox: 4.6,
  cloud: 4.5,
  bayonetta: 4.3,
  sheik: 4.3,
  pikachu: 4.2,
  diddyKong: 4.1
});
const pit = new Fighter(19, "Pit", "pit", pitImg, 10, "Side-B", {
  defaultOpponent: null,
  pit: 5.0,
  qezox: 6,
  daciex: 6,
  zeldark: 5.5,
  drMario: 6.0,
  jigglypuff: 6.0,
  ganondorf: 6.0,
  littleMac: 5.9,
  zelda: 5.8,
  duckHunt: 5.8,
  wiiFitTrainer: 5.8,
  kingDedede: 5.8,
  kirby: 5.7,
  bowserJr: 5.7,
  charizard: 5.7,
  palutena: 5.6,
  pacMan: 5.5,
  shulk: 5.5,
  roy: 5.5,
  samus: 5.4,
  ness: 5.4,
  mrGameAndWatch: 5.4,
  falco: 5.3,
  link: 5.3,
  wario: 5.3,
  lucas: 5.2,
  tactician: 5.2,
  ike: 5.2,
  lucina: 5.1,
  peach: 5.1,
  olimar: 5.1,
  yoshi: 5.1,
  rob: 5.1,
  toonLink: 5.1,
  darkPit: 5.0,
  bowser: 5.0,
  donkeyKong: 5.0,
  villager: 4.9,
  luigi: 4.9,
  lucario: 4.8,
  marth: 4.8,
  megaMan: 4.7,
  metaKnight: 4.7,
  greninja: 4.7,
  corrin: 4.7,
  pikachu: 4.6,
  ryu: 4.6,
  mewTwo: 4.5,
  captainFalcon: 4.5,
  rosalina: 4.5,
  mario: 4.5,
  zss: 4.4,
  cloud: 4.4,
  diddyKong: 4.4,
  fox: 4.4,
  sheik: 4.3,
  sonic: 4.0,
  bayonetta: 3.9
});
const palutena = new Fighter(20, "Palutena", "palutena", palutenaImg, 5, "Counter KO", {
  defaultOpponent: null,
  palutena: 5.0,
  qezox: 4,
  daciex: 4,
  zeldark: 4,
  duckHunt: 6.1,
  zelda: 5.8,
  pacMan: 5.5,
  bowserJr: 5.4,
  samus: 5.4,
  jigglypuff: 5.3,
  ganondorf: 5.3,
  wiiFitTrainer: 5.1,
  kingDedede: 5.0,
  link: 4.9,
  lucario: 4.9,
  villager: 4.9,
  roy: 4.9,
  drMario: 4.8,
  charizard: 4.8,
  littleMac: 4.7,
  mrGameAndWatch: 4.7,
  falco: 4.7,
  donkeyKong: 4.6,
  megaMan: 4.6,
  shulk: 4.6,
  wario: 4.6,
  lucina: 4.5,
  rob: 4.5,
  kirby: 4.4,
  lucas: 4.4,
  pit: 4.4,
  ike: 4.3,
  olimar: 4.3,
  bowser: 4.3,
  tactician: 4.2,
  yoshi: 4.2,
  darkPit: 4.2,
  peach: 4.2,
  greninja: 4.1,
  toonLink: 4.1,
  corrin: 4.0,
  metaKnight: 4.0,
  marth: 4.0,
  luigi: 4.0,
  captainFalcon: 4.0,
  mario: 3.9,
  pikachu: 3.9,
  rosalina: 3.9,
  ryu: 3.9,
  ness: 3.9,
  bayonetta: 3.9,
  cloud: 3.8,
  fox: 3.7,
  mewTwo: 3.7,
  diddyKong: 3.6,
  sheik: 3.4,
  zss: 3.4,
  sonic: 3.1
});
const marth = new Fighter(21, "Marth", "marth", marthImg, 6, "Shield Break KO", {
  defaultOpponent: null,
  marth: 5.0,
  qezox: 5.5,
  daciex: 6.3,
  zeldark: 5.2,
  jigglypuff: 7.1,
  ganondorf: 6.5,
  drMario: 6.5,
  kirby: 6.4,
  zelda: 6.3,
  charizard: 6.2,
  bowserJr: 6.1,
  littleMac: 6.1,
  kingDedede: 6.1,
  mrGameAndWatch: 6.0,
  palutena: 6.0,
  shulk: 6.0,
  wiiFitTrainer: 6.0,
  roy: 6.0,
  falco: 6.0,
  luigi: 5.9,
  wario: 5.9,
  link: 5.9,
  duckHunt: 5.9,
  pacMan: 5.8,
  samus: 5.7,
  ike: 5.7,
  ness: 5.6,
  tactician: 5.6,
  lucas: 5.6,
  bowser: 5.5,
  lucina: 5.4,
  peach: 5.4,
  donkeyKong: 5.4,
  lucario: 5.4,
  rob: 5.4,
  villager: 5.3,
  mario: 5.3,
  captainFalcon: 5.3,
  toonLink: 5.3,
  yoshi: 5.3,
  pit: 5.2,
  greninja: 5.2,
  darkPit: 5.0,
  pikachu: 5.0,
  ryu: 5.0,
  olimar: 5.0,
  corrin: 5.0,
  mewTwo: 4.9,
  metaKnight: 4.9,
  zss: 4.9,
  megaMan: 4.8,
  sheik: 4.7,
  fox: 4.7,
  cloud: 4.6,
  bayonetta: 4.6,
  rosalina: 4.2,
  diddyKong: 4.2,
  sonic: 4.0
});
const ike = new Fighter(22, "Ike", "ike", ikeImg, 7, "Eruption Non-Gimp", {
  defaultOpponent: null,
  ike: 5.0,
  qezox: 4,
  daciex: 6,
  zeldark: 5,
  jigglypuff: 6.5,
  kirby: 6.3,
  duckHunt: 6.0,
  zelda: 6.0,
  ganondorf: 5.9,
  bowserJr: 5.7,
  palutena: 5.7,
  littleMac: 5.6,
  kingDedede: 5.6,
  mrGameAndWatch: 5.5,
  charizard: 5.5,
  shulk: 5.4,
  drMario: 5.3,
  roy: 5.3,
  wario: 5.2,
  samus: 5.2,
  lucario: 5.2,
  lucas: 5.2,
  wiiFitTrainer: 5.2,
  link: 5.1,
  falco: 5.1,
  lucina: 5.1,
  darkPit: 4.9,
  yoshi: 4.9,
  peach: 4.9,
  pit: 4.8,
  pacMan: 4.7,
  ness: 4.7,
  tactician: 4.7,
  donkeyKong: 4.6,
  luigi: 4.6,
  toonLink: 4.6,
  metaKnight: 4.5,
  rob: 4.5,
  ryu: 4.4,
  captainFalcon: 4.4,
  marth: 4.3,
  olimar: 4.3,
  bowser: 4.3,
  corrin: 4.3,
  mewTwo: 4.3,
  greninja: 4.2,
  villager: 4.2,
  fox: 4.1,
  cloud: 4.1,
  megaMan: 4.0,
  mario: 4.0,
  zss: 4.0,
  pikachu: 4.0,
  rosalina: 3.9,
  bayonetta: 3.9,
  sonic: 3.7,
  diddyKong: 3.6,
  sheik: 3.3
});
const tactician = new Fighter(23, "Tactician", "tactician", tacticianImg, 6, "Gust Spike", {
  defaultOpponent: null,
  tactician: 5.0,
  qezox: 5,
  daciex: 5.6,
  zeldark: 5,
  kingDedede: 6.2,
  charizard: 6.0,
  ganondorf: 5.9,
  jigglypuff: 5.8,
  bowserJr: 5.8,
  palutena: 5.8,
  donkeyKong: 5.8,
  zelda: 5.7,
  littleMac: 5.7,
  roy: 5.7,
  wario: 5.6,
  shulk: 5.6,
  wiiFitTrainer: 5.5,
  lucina: 5.4,
  pacMan: 5.3,
  duckHunt: 5.3,
  ike: 5.3,
  luigi: 5.3,
  samus: 5.3,
  link: 5.3,
  peach: 5.1,
  bowser: 5.1,
  mrGameAndWatch: 5.1,
  rob: 5.1,
  kirby: 5.1,
  drMario: 5.0,
  lucas: 4.9,
  olimar: 4.8,
  pit: 4.8,
  falco: 4.7,
  darkPit: 4.7,
  yoshi: 4.7,
  metaKnight: 4.6,
  captainFalcon: 4.5,
  ryu: 4.5,
  marth: 4.4,
  lucario: 4.4,
  villager: 4.3,
  corrin: 4.2,
  sonic: 4.2,
  megaMan: 4.2,
  ness: 4.1,
  pikachu: 4.1,
  toonLink: 4.1,
  greninja: 4.1,
  rosalina: 4.0,
  diddyKong: 3.9,
  cloud: 3.9,
  mario: 3.8,
  mewTwo: 3.8,
  sheik: 3.8,
  fox: 3.8,
  zss: 3.7,
  bayonetta: 3.4
});
const duckHunt = new Fighter(24, "Duck Hunt", "duckHunt", duckHuntImg, 5, "Can KO Combo", {
  defaultOpponent: null,
  duckHunt: 5.0,
  qezox: 5,
  daciex: 5.5,
  zeldark: 5,
  ganondorf: 5.7,
  samus: 5.7,
  wiiFitTrainer: 5.6,
  zelda: 5.6,
  jigglypuff: 5.6,
  kingDedede: 5.4,
  kirby: 5.3,
  bowserJr: 5.3,
  shulk: 5.0,
  littleMac: 4.9,
  charizard: 4.8,
  roy: 4.8,
  bowser: 4.8,
  pacMan: 4.8,
  luigi: 4.7,
  ryu: 4.7,
  wario: 4.7,
  tactician: 4.7,
  mrGameAndWatch: 4.6,
  drMario: 4.6,
  donkeyKong: 4.6,
  greninja: 4.5,
  lucas: 4.5,
  yoshi: 4.5,
  peach: 4.5,
  falco: 4.4,
  megaMan: 4.4,
  link: 4.4,
  olimar: 4.3,
  ness: 4.3, pit: 4.2,
  lucina: 4.2,
  toonLink: 4.1,
  marth: 4.1,
  metaKnight: 4.1,
  corrin: 4.0,
  villager: 4.0,
  ike: 4.0,
  diddyKong: 4.0,
  captainFalcon: 4.0,
  pikachu: 4.0,
  palutena: 3.9,
  rob: 3.9,
  sheik: 3.8,
  zss: 3.8,
  mario: 3.7,
  darkPit: 3.7,
  rosalina: 3.7,
  sonic: 3.7,
  lucario: 3.6,
  bayonetta: 3.5,
  fox: 3.4,
  mewTwo: 3.4,
  cloud: 3.4
});
const kirby = new Fighter(25, "Kirby", "kirby", kirbyImg, 5, "Inhale Fall", {
  defaultOpponent: null,
  kirby: 5.0,
  qezox: 5,
  daciex: 5,
  zeldark: 4.5,
  zelda: 6.0,
  jigglypuff: 5.6,
  littleMac: 5.6,
  palutena: 5.6,
  captainFalcon: 5.6,
  wiiFitTrainer: 5.6,
  falco: 5.5,
  ganondorf: 5.5,
  bowserJr: 5.3,
  kingDedede: 5.3,
  pacMan: 5.2,
  mrGameAndWatch: 5.1,
  olimar: 5.0,
  drMario: 5.0,
  tactician: 4.9,
  shulk: 4.9,
  fox: 4.9,
  lucas: 4.8,
  wario: 4.8,
  duckHunt: 4.7,
  rob: 4.6,
  peach: 4.6,
  roy: 4.6,
  yoshi: 4.5,
  lucario: 4.5,
  bowser: 4.5,
  megaMan: 4.5,
  charizard: 4.5,
  pikachu: 4.4,
  sheik: 4.4,
  greninja: 4.4,
  villager: 4.4,
  ness: 4.4,
  link: 4.3,
  samus: 4.3,
  darkPit: 4.3,
  pit: 4.3,
  mario: 4.3,
  zss: 4.2,
  donkeyKong: 4.2,
  ryu: 4.1,
  toonLink: 4.1,
  metaKnight: 4.0,
  luigi: 4.0,
  mewTwo: 3.9,
  corrin: 3.9,
  lucina: 3.9,
  diddyKong: 3.8,
  rosalina: 3.7,
  ike: 3.7,
  cloud: 3.7,
  bayonetta: 3.6,
  marth: 3.6,
  sonic: 2.9
});
const kingDedede = new Fighter(26, "King Dedede", "kingDedede", kingDededeImg, 5, "Inhale Fall", {
  defaultOpponent: null,
  kingDedede: 5.0,
  qezox: 4,
  daciex: 5,
  zeldark: 4.5,
  jigglypuff: 5.7,
  littleMac: 5.5,
  ganondorf: 5.2,
  mrGameAndWatch: 5.2,
  palutena: 5.0,
  charizard: 5.0,
  wiiFitTrainer: 4.8,
  bowserJr: 4.8,
  kirby: 4.7,
  olimar: 4.7,
  zelda: 4.7,
  duckHunt: 4.6,
  wario: 4.6,
  donkeyKong: 4.5,
  darkPit:4.4,
  ike: 4.4,
  roy: 4.4,
  drMario: 4.4,
  shulk: 4.4,
  luigi: 4.4,
  lucario: 4.3,
  yoshi: 4.3,
  pacMan: 4.3,
  lucas: 4.3,
  lucina: 4.3,
  pit: 4.2,
  bowser: 4.2,
  peach: 4.2,
  metaKnight: 4.0,
  greninja: 4.0,
  falco: 4.0,
  samus: 4.0,
  ryu: 3.9,
  rob: 3.9,
  marth: 3.9,
  link: 3.8,
  tactician: 3.8,
  ness: 3.8,
  toonLink: 3.8,
  captainFalcon: 3.8,
  mewTwo: 3.8,
  mario: 3.8,
  corrin: 3.7,
  villager: 3.6,
  megaMan: 3.5,
  pikachu: 3.4,
  rosalina: 3.4,
  fox: 3.4,
  sheik: 3.0,
  diddyKong: 3.0,
  sonic: 2.9,
  cloud: 2.9,
  zss: 2.9,
  bayonetta: 2.3
});
const metaKnight = new Fighter(27, "Meta Knight", "metaKnight", metaKnightImg, 4, "Teleport KO", {
  defaultOpponent: null,
  metaKnight: 5.0,
  qezox: 5,
  daciex: 6,
  zeldark: 4.5,
  jigglypuff: 6.8,
  zelda: 6.7,
  charizard: 6.2,
  mrGameAndWatch: 6.2,
  link: 6.2,
  ganondorf: 6.2,
  littleMac: 6.1,
  peach: 6.1,
  roy: 6.0,
  rosalina: 6.0,
  bowser: 6.0,
  bowserJr: 6.0,
  samus: 6.0,
  palutena: 6.0,
  kingDedede: 6.0,
  kirby: 6.0,
  duckHunt: 5.9,
  donkeyKong: 5.9,
  wiiFitTrainer: 5.8,
  darkPit: 5.8,
  falco: 5.8,
  pacMan: 5.7,
  drMario: 5.7,
  ness: 5.7,
  shulk: 5.6,
  wario: 5.6,
  captainFalcon: 5.6,
  lucina: 5.5,
  lucario: 5.5,
  ike: 5.5,
  yoshi: 5.5,
  villager: 5.4,
  tactician: 5.4,
  toonLink: 5.4,
  lucas: 5.4,
  rob: 5.3,
  megaMan: 5.3,
  luigi: 5.3,
  pit: 5.3,
  greninja: 5.3,
  olimar: 5.2,
  marth: 5.1,
  corrin: 5.0,
  pikachu: 4.9,
  mewTwo: 4.9,
  ryu: 4.8,
  cloud: 4.7,
  fox: 4.7,
  zss: 4.7,
  sheik: 4.6,
  bayonetta: 4.5,
  mario: 4.5,
  sonic: 4.4,
  diddyKong: 4.2
});
const fox = new Fighter(28, "Fox", "fox", foxImg, 4, "Falling Forward Air W/ Recovery", {
  defaultOpponent: null,
  fox: 5.0,
  qezox: 6,
  daciex: 5.5,
  zeldark: 4.5,
  samus: 6.8,
  kingDedede: 6.6,
  duckHunt: 6.6,
  zelda: 6.5,
  wiiFitTrainer: 6.5,
  jigglypuff: 6.4,
  megaMan: 6.4,
  link: 6.4,
  ganondorf: 6.4,
  olimar: 6.4,
  charizard: 6.4,
  palutena: 6.3,
  bowserJr: 6.3,
  shulk: 6.2,
  tactician: 6.2,
  roy: 6.2,
  mrGameAndWatch: 6.2,
  lucario: 6.1,
  falco: 6.0,
  pacMan: 6.0,
  drMario: 6.0,
  ike: 5.9,
  bowser: 5.9,
  wario: 5.9,
  donkeyKong: 5.8,
  toonLink: 5.8,
  littleMac: 5.8,
  ness: 5.7,
  rob: 5.7,
  villager: 5.6,
  darkPit: 5.6,
  pit: 5.6,
  captainFalcon: 5.6,
  lucas: 5.6,
  peach: 5.5,
  greninja: 5.5,
  zss: 5.4,
  corrin: 5.4,
  sonic: 5.4,
  lucina: 5.3,
  metaKnight: 5.3,
  marth: 5.3,
  pikachu: 5.2,
  kirby: 5.1,
  yoshi: 5.0,
  mewTwo: 5.0,
  luigi: 4.9,
  sheik: 4.8,
  diddyKong: 4.8,
  mario: 4.8,
  rosalina: 4.8,
  cloud: 4.7,
  bayonetta: 4.7,
  ryu: 4.5
});
const falco = new Fighter(29, "Falco", "falco", falcoImg, 6, "Sibe-B Spike", {
  defaultOpponent: null,
  falco: 5.0,
  qezox: 5,
  daciex: 5,
  zeldark: 4.5,
  kingDedede: 6.0,
  jigglypuff: 5.8,
  ganondorf: 5.7,
  pacMan: 5.6,
  duckHunt: 5.6,
  zelda: 5.6,
  palutena: 5.3,
  samus: 5.3,
  tactician: 5.3,
  bowserJr: 5.2,
  wiiFitTrainer: 5.2,
  charizard: 5.1,
  mrGameAndWatch: 5.1,
  rob: 5.1,
  littleMac: 5.1,
  shulk: 5.0,
  ike: 4.9,
  drMario: 4.9,
  wario: 4.9,
  villager: 4.8,
  peach: 4.8,
  toonLink: 4.8,
  link: 4.8,
  ness: 4.7,
  olimar: 4.7,
  pit: 4.7,
  megaMan: 4.6,
  darkPit: 4.6,
  lucina: 4.6,
  roy: 4.5,
  kirby: 4.5,
  ryu: 4.5,
  corrin: 4.5,
  lucas: 4.4,
  greninja: 4.4,
  donkeyKong: 4.4,
  lucario: 4.3,
  bowser: 4.3,
  yoshi: 4.2,
  metaKnight: 4.2,
  captainFalcon: 4.1,
  marth: 4.0,
  zss: 4.0,
  fox: 4.0,
  sheik: 4.0,
  sonic: 3.9,
  mewTwo: 3.9,
  cloud: 3.8,
  mario: 3.8,
  diddyKong: 3.8,
  luigi: 3.8,
  pikachu: 3.8,
  rosalina: 3.7,
  bayonetta: 3.5
});
const pikachu = new Fighter(30, "Pikachu", "pikachu", pikachuImg, 4, "Thunder KO", {
  defaultOpponent: null,
  pikachu: 5.0,
  qezox: 5.3,
  daciex: 5.6,
  zeldark: 4.9,
  ganondorf: 6.7,
  littleMac: 6.6,
  kingDedede: 6.6,
  zelda: 6.4,
  samus: 6.4,
  roy: 6.2,
  captainFalcon: 6.2,
  falco: 6.2,
  charizard: 6.2,
  jigglypuff: 6.1,
  wiiFitTrainer: 6.1,
  palutena: 6.1,
  bowser: 6.1,
  bowserJr: 6.1,
  duckHunt: 6.0,
  ike: 6.0,
  donkeyKong: 6.0,
  link: 6.0,
  shulk: 5.9,
  tactician: 5.9,
  zss: 5.8,
  wario: 5.8,
  pacMan: 5.7,
  rob: 5.7,
  toonLink: 5.7,
  lucina: 5.6,
  peach: 5.6,
  kirby: 5.6,
  drMario: 5.5,
  darkPit: 5.5,
  olimar: 5.4,
  villager: 5.4,
  greninja: 5.4,
  pit: 5.4,
  corrin: 5.3,
  yoshi: 5.1,
  metaKnight: 5.1,
  megaMan: 5.1,
  luigi: 5.1,
  lucas: 5.1,
  marth: 5.0,
  cloud: 5.0,
  ryu: 4.9,
  rosalina: 4.8,
  lucario: 4.8,
  fox: 4.8,
  bayonetta: 4.8,
  mewTwo: 4.8,
  mrGameAndWatch: 4.8,
  sheik: 4.7,
  diddyKong: 4.7,
  sonic: 4.6,
  ness: 4.3,
  mario: 4.0
});
const charizard = new Fighter(31, "Charizard", "charizard", charizardImg, 7, "Flameburst From Stage KO", {
  defaultOpponent: null,
  charizard: 5.0,
  qezox: 5.5,
  daciex: 6,
  zeldark: 5,
  bowserJr: 5.7,
  zelda: 5.6,
  jigglypuff: 5.6,
  kirby: 5.5,
  ganondorf: 5.3,
  palutena: 5.2,
  duckHunt: 5.2,
  drMario: 5.1,
  samus: 5.1,
  link: 5.1,
  mrGameAndWatch: 5.0,
  kingDedede: 5.0,
  wario: 4.9,
  wiiFitTrainer: 4.9,
  falco: 4.9,
  pacMan: 4.8,
  shulk: 4.7,
  lucina: 4.7,
  donkeyKong: 4.6,
  roy: 4.5,
  ike: 4.5,
  littleMac: 4.5,
  yoshi: 4.5,
  peach: 4.4,
  greninja: 4.4,
  bowser: 4.3,
  pit: 4.3,
  luigi: 4.3,
  olimar: 4.3,
  lucas: 4.2,
  toonLink: 4.2,
  lucario: 4.2,
  rob: 4.1,
  corrin: 4.0,
  megaMan: 4.0,
  mewTwo: 4.0,
  tactician: 4.0,
  ness: 4.0,
  ryu: 3.9,
  darkPit: 3.9,
  pikachu: 3.8,
  mario: 3.8,
  marth: 3.8,
  cloud: 3.8,
  sheik: 3.8,
  metaKnight: 3.8,
  villager: 3.6,
  fox: 3.6,
  captainFalcon: 3.5,
  rosalina: 3.4,
  diddyKong: 3.4,
  bayonetta: 3.0,
  sonic: 3.0,
  zss: 2.9
});
const lucario = new Fighter(32, "Lucario", "lucario", lucarioImg, 5, "Command Grab KO", {
  defaultOpponent: null,
  lucario: 5.0,
  qezox: 5,
  daciex: 5,
  zeldark: 4.5,
  duckHunt: 6.4,
  jigglypuff: 6.4,
  zelda: 6.3,
  pacMan: 6.2,
  bowserJr: 6.1,
  link: 6.1,
  samus: 6.0,
  roy: 5.9,
  wiiFitTrainer: 5.9,
  olimar: 5.9,
  shulk: 5.9,
  charizard: 5.8,
  ganondorf: 5.8,
  luigi: 5.8,
  kingDedede: 5.7,
  falco: 5.7,
  tactician: 5.6,
  peach: 5.6,
  drMario: 5.6,
  toonLink: 5.6,
  kirby: 5.5,
  greninja: 5.5,
  lucas: 5.4,
  littleMac: 5.4,
  megaMan: 5.4,
  darkPit: 5.2,
  pikachu: 5.2,
  pit: 5.2,
  rob: 5.1,
  palutena: 5.1,
  villager: 5.1,
  yoshi: 5.1,
  mrGameAndWatch: 5.0,
  captainFalcon: 5.0,
  lucina: 5.0,
  sonic: 4.8,
  bowser: 4.8,
  ike: 4.8,
  sheik: 4.8,
  corrin: 4.7,
  wario: 4.6,
  marth: 4.6,
  ness: 4.6,
  mewTwo: 4.6,
  mario: 4.5,
  rosalina: 4.5,
  zss: 4.5,
  donkeyKong: 4.5,
  metaKnight: 4.5,
  diddyKong: 4.4,
  ryu: 4.4,
  bayonetta: 4.3,
  cloud: 4.2,
  fox: 3.9
});
const jigglypuff = new Fighter(33, "Jigglypuff", "jigglypuff", jigglypuffImg, 5, "Sing", {
  defaultOpponent: null,
  jigglypuff: 5.0,
  qezox: 4,
  daciex: 5.5,
  zeldark: 4.5,
  littleMac: 5.3,
  bowserJr: 4.8,
  zelda: 4.7,
  palutena: 4.7,
  ganondorf: 4.6,
  drMario: 4.5,
  wiiFitTrainer: 4.5,
  duckHunt: 4.4,
  mrGameAndWatch: 4.4,
  charizard: 4.4,
  kirby: 4.4,
  pacMan: 4.4,
  kingDedede: 4.3,
  olimar: 4.2,
  lucas: 4.2,
  captainFalcon: 4.2,
  falco: 4.2,
  tactician: 4.2,
  samus: 4.1,
  pit: 4.0,
  ness: 4.0,
  wario: 3.9,
  link: 3.9,
  pikachu: 3.9,
  luigi: 3.9,
  peach: 3.9,
  shulk: 3.9,
  rob: 3.9,
  villager: 3.9,
  darkPit: 3.8,
  megaMan: 3.8,
  bowser: 3.7,
  roy: 3.6,
  lucario: 3.6,
  fox: 3.6,
  greninja: 3.6,
  zss: 3.6,
  donkeyKong: 3.6,
  ike: 3.5,
  yoshi: 3.5,
  sheik: 3.5,
  rosalina: 3.3,
  mewTwo: 3.2,
  corrin: 3.2,
  metaKnight: 3.2,
  toonLink: 3.2,
  lucina: 3.2,
  diddyKong: 3.1,
  mario: 3.1,
  bayonetta: 3.1,
  ryu: 3.0,
  cloud: 2.9,
  marth: 2.9,
  sonic: 2.8
});
const greninja = new Fighter(34, "Greninja", "greninja", greninjaImg, 3, "Down-Air Spike", {
  defaultOpponent: null,
  greninja: 5.0,
  qezox: 4.5,
  daciex: 4.5,
  zeldark: 4,
  ganondorf: 6.5,
  jigglypuff: 6.4,
  littleMac: 6.1,
  drMario: 6.1,
  kingDedede: 6.0,
  bowserJr: 6.0,
  zelda: 5.9,
  tactician: 5.9,
  palutena: 5.9,
  roy: 5.8,
  mrGameAndWatch: 5.8,
  ike: 5.8,
  wiiFitTrainer: 5.8,
  pacMan: 5.7,
  shulk: 5.7,
  charizard: 5.6,
  wario: 5.6,
  falco: 5.6,
  kirby: 5.6,
  rob: 5.6,
  link: 5.5,
  lucas: 5.5,
  duckHunt: 5.5,
  donkeyKong: 5.5,
  samus: 5.4,
  toonLink: 5.4,
  bowser: 5.4,
  villager: 5.3,
  lucina: 5.3,
  pit: 5.3,
  peach: 5.2,
  captainFalcon: 5.2,
  yoshi: 5.0,
  olimar: 5.0,
  luigi: 5.0,
  ness: 5.0,
  megaMan: 5.0,
  darkPit: 4.9,
  marth: 4.8,
  ryu: 4.8,
  metaKnight: 4.7,
  zss: 4.7,
  mario: 4.6,
  mewTwo: 4.6,
  corrin: 4.6,
  pikachu: 4.6,
  bayonetta: 4.6,
  lucario: 4.5,
  fox: 4.5,
  cloud: 4.4,
  diddyKong: 4.3,
  sheik: 4.2,
  rosalina: 4.1,
  sonic: 4.1
});
const rob = new Fighter(35, "ROB", "rob", robImg, 5, "Side-B Off-Air Play", {
  defaultOpponent: null,
  rob: 5.0,
  qezox: 4,
  daciex: 6,
  zeldark: 5.2,
  ganondorf: 6.3,
  wiiFitTrainer: 6.2,
  jigglypuff: 6.1,
  duckHunt: 6.1,
  kingDedede: 6.1,
  bowserJr: 6.1,
  littleMac: 6.0,
  charizard: 5.9,
  zelda: 5.9,
  donkeyKong: 5.8,
  drMario: 5.7,
  wario: 5.6,
  bowser: 5.6,
  pacMan: 5.6,
  ike: 5.5,
  darkPit: 5.5,
  palutena: 5.5,
  samus: 5.4,
  roy: 5.4,
  kirby: 5.4,
  mrGameAndWatch: 5.3,
  shulk: 5.3,
  link: 5.2,
  peach: 5.1,
  lucina: 5.0,
  megaMan: 5.0,
  ness: 5.0,
  tactician: 4.9,
  lucas: 4.9,
  falco: 4.9,
  pit: 4.9,
  lucario: 4.9,
  luigi: 4.8,
  yoshi: 4.8,
  ryu: 4.7,
  metaKnight: 4.7,
  toonLink: 4.6,
  marth: 4.6,
  olimar: 4.5,
  villager: 4.5,
  greninja: 4.4,
  captainFalcon: 4.4,
  corrin: 4.4,
  fox: 4.3,
  pikachu: 4.3,
  bayonetta: 4.1,
  sheik: 4.1,
  mario: 4.0,
  diddyKong: 4.0,
  mewTwo: 4.0,
  cloud: 4.0,
  sonic: 3.9,
  zss: 3.8,
  rosalina: 3.7
});
const ness = new Fighter(36, "Ness", "ness", nessImg, 7, "PK Flash", {
  defaultOpponent: null,
  ness: 5.0,
  qezox: 6,
  daciex: 6.5,
  zeldark: 5.5,
  wiiFitTrainer: 6.6,
  ganondorf: 6.3,
  littleMac: 6.2,
  zelda: 6.2,
  kingDedede: 6.2,
  bowserJr: 6.1,
  samus: 6.1,
  palutena: 6.1,
  charizard: 6.0,
  jigglypuff: 6.0,
  tactician: 5.9,
  duckHunt: 5.7,
  drMario: 5.7,
  roy: 5.7,
  pikachu: 5.7,
  captainFalcon: 5.7,
  kirby: 5.6,
  bowser: 5.5,
  donkeyKong: 5.4,
  lucario: 5.4,
  wario: 5.4,
  link: 5.3,
  falco: 5.3,
  ike: 5.3,
  peach: 5.3,
  pacMan: 5.2,
  shulk: 5.0,
  greninja: 5.0,
  luigi: 5.0,
  rob: 5.0,
  mrGameAndWatch: 4.9,
  lucas: 4.9,
  toonLink: 4.9,
  olimar: 4.8,
  ryu: 4.8,
  yoshi: 4.7,
  pit: 4.6,
  darkPit: 4.5,
  megaMan: 4.5,
  lucina: 4.5,
  bayonetta: 4.5,
  mewTwo: 4.5,
  zss: 4.4,
  marth: 4.4,
  metaKnight: 4.3,
  fox: 4.3,
  corrin: 4.3,
  mario: 4.2,
  sonic: 4.2,
  diddyKong: 4.1,
  villager: 4.1,
  cloud: 4.0,
  sheik: 3.8,
  rosalina: 2.8
});
const captainFalcon = new Fighter(37, "Captain Falcon", "captainFalcon", captainFalconImg, 6, "Falcon Punch", {
  defaultOpponent: null,
  captainFalcon: 5.0,
  qezox: 4.5,
  daciex: 5,
  zeldark: 4.5,
  zelda: 6.6,
  ganondorf: 6.5,
  charizard: 6.5,
  wiiFitTrainer: 6.3,
  kingDedede: 6.2,
  bowserJr: 6.1,
  palutena: 6.0,
  duckHunt: 6.0,
  mrGameAndWatch: 6.0,
  falco: 5.9,
  link: 5.9,
  jigglypuff: 5.8,
  littleMac: 5.7,
  drMario: 5.7,
  samus: 5.7,
  bowser: 5.7,
  ike: 5.6,
  donkeyKong: 5.6,
  roy: 5.6,
  pacMan: 5.6,
  rob: 5.6,
  tactician: 5.5,
  darkPit: 5.5,
  pit: 5.5,
  shulk: 5.5,
  wario: 5.4,
  lucina: 5.3,
  lucas: 5.3,
  peach: 5.3,
  yoshi: 5.1,
  lucario: 5.0,
  villager: 5.0,
  olimar: 5.0,
  toonLink: 4.9,
  greninja: 4.8,
  sonic: 4.7,
  marth: 4.7,
  corrin: 4.7,
  luigi: 4.6,
  mewTwo: 4.5,
  kirby: 4.4,
  metaKnight: 4.4,
  fox: 4.4,
  ryu: 4.4,
  ness: 4.3,
  megaMan: 4.3,
  mario: 4.3,
  rosalina: 4.3,
  zss: 4.2,
  cloud: 4.2,
  diddyKong: 4.1,
  bayonetta: 3.9,
  pikachu: 3.8,
  sheik: 3.6
});
const villager = new Fighter(38, "Villager", "villager", villagerImg, 5, "Treefall", {
  defaultOpponent: null,
  villager: 5.0,
  qezox: 6,
  daciex: 6.5,
  zeldark: 6,
  ganondorf: 6.6,
  bowserJr: 6.6,
  kingDedede: 6.4,
  charizard: 6.4,
  jigglypuff: 6.1,
  wiiFitTrainer: 6.1,
  samus: 6.1,
  littleMac: 6.1,
  bowser: 6.1,
  zelda: 6.0,
  duckHunt: 6.0,
  pacMan: 5.9,
  donkeyKong: 5.9,
  ness: 5.9,
  wario: 5.9,
  ike: 5.8,
  drMario: 5.8,
  roy: 5.7,
  tactician: 5.7,
  shulk: 5.7,
  kirby: 5.6,
  link: 5.5,
  rob: 5.5,
  mrGameAndWatch: 5.5,
  luigi: 5.4,
  peach: 5.3,
  toonLink: 5.3,
  lucas: 5.2,
  falco: 5.2,
  ryu: 5.1,
  palutena: 5.1,
  pit: 5.1,
  yoshi: 5.0,
  lucina: 5.0,
  captainFalcon: 5.0,
  megaMan: 5.0,
  lucario: 4.9,
  olimar: 4.8,
  corrin: 4.8,
  darkPit: 4.8,
  greninja: 4.7,
  marth: 4.7,
  diddyKong: 4.6,
  pikachu: 4.6,
  zss: 4.6,
  metaKnight: 4.6,
  bayonetta: 4.6,
  sonic: 4.5,
  fox: 4.4,
  mewTwo: 4.4,
  sheik: 4.3,
  mario: 4.3,
  rosalina: 4.0,
  cloud: 4.0
});
const olimar = new Fighter(39, "Olimar", "olimar", olimarImg, 4, "Purple F-Air", {
  defaultOpponent: null,
  olimar: 5.0,
  qezox: 4,
  daciex: 5,
  zeldark: 4.5,
  zelda: 6.2,
  samus: 6.1,
  roy: 6.1,
  link: 5.9,
  donkeyKong: 5.9,
  bowserJr: 5.8,
  jigglypuff: 5.8,
  wiiFitTrainer: 5.8,
  ganondorf: 5.8,
  charizard: 5.7,
  pacMan: 5.7,
  palutena: 5.7,
  duckHunt: 5.7,
  ike: 5.7,
  drMario: 5.7,
  mrGameAndWatch: 5.6,
  lucas: 5.5,
  peach: 5.5,
  rob: 5.5,
  falco: 5.3,
  littleMac: 5.3,
  wario: 5.3,
  kingDedede: 5.3,
  ness: 5.2,
  yoshi: 5.2,
  luigi: 5.2,
  tactician: 5.2,
  villager: 5.2,
  marth: 5.0,
  captainFalcon: 5.0,
  greninja: 5.0,
  ryu: 5.0,
  kirby: 5.0,
  shulk: 4.9,
  zss: 4.9,
  pit: 4.9,
  diddyKong: 4.8,
  bowser: 4.8,
  metaKnight: 4.8,
  lucina: 4.8,
  corrin: 4.6,
  pikachu: 4.6,
  darkPit: 4.3,
  sheik: 4.3,
  toonLink: 4.3,
  mario: 4.2,
  rosalina: 4.2,
  megaMan: 4.1,
  mewTwo: 4.1,
  lucario: 4.1,
  bayonetta: 4.1,
  sonic: 4.1,
  cloud: 4.0,
  fox: 3.6
});
const wiiFitTrainer = new Fighter(40, "Wii Fit Trainer", "wiiFitTrainer", wiiFitTrainerImg, 5, "Deep Breathing Heal Missile", {
  defaultOpponent: null,
  wiiFitTrainer: 5.0,
  qezox: 5,
  daciex: 5,
  zeldark: 4.5,
  jigglypuff: 5.5,
  ganondorf: 5.5,
  kingDedede: 5.2,
  charizard: 5.1,
  roy: 5.0,
  zelda: 5.0,
  bowserJr: 5.0,
  drMario: 4.9,
  palutena: 4.9,
  littleMac: 4.9,
  pacMan: 4.9,
  falco: 4.8,
  ike: 4.8,
  mrGameAndWatch: 4.8,
  samus: 4.8,
  luigi: 4.7,
  yoshi: 4.7,
  link: 4.7,
  donkeyKong: 4.6,
  shulk: 4.6,
  tactician: 4.5,
  wario: 4.5,
  kirby: 4.4,
  duckHunt: 4.4,
  toonLink: 4.4,
  bowser: 4.3,
  ryu: 4.3,
  corrin: 4.3,
  greninja: 4.2,
  olimar: 4.2,
  megaMan: 4.2,
  pit: 4.2,
  darkPit: 4.2,
  metaKnight: 4.2,
  peach: 4.1,
  lucario: 4.1,
  marth: 4.0,
  lucas: 4.0,
  lucina: 4.0,
  diddyKong: 3.9,
  pikachu: 3.9,
  villager: 3.9,
  mewTwo: 3.9,
  rosalina: 3.9,
  rob: 3.8,
  zss: 3.7,
  sheik: 3.7,
  sonic: 3.7,
  captainFalcon: 3.7,
  bayonetta: 3.6,
  mario: 3.5,
  fox: 3.5,
  cloud: 3.4,
  ness: 3.4
});
const shulk = new Fighter(41, "Shulk", "shulk", shulkImg, 4, "Up-B Return Intercept", {
  defaultOpponent: null,
  shulk: 5.0,
  qezox: 4.5,
  daciex: 6,
  zeldark: 4.5,
  jigglypuff: 6.1,
  zelda: 5.9,
  ganondorf: 5.9,
  kingDedede: 5.6,
  bowserJr: 5.5,
  lucas: 5.5,
  wario: 5.5,
  palutena: 5.4,
  wiiFitTrainer: 5.4,
  drMario: 5.4,
  charizard: 5.3,
  pacMan: 5.3,
  littleMac: 5.3,
  luigi: 5.2,
  roy: 5.2,
  kirby: 5.1,
  olimar: 5.1,
  falco: 5.0,
  duckHunt: 5.0,
  ness: 5.0,
  mrGameAndWatch: 5.0,
  samus: 5.0,
  link: 4.9,
  lucina: 4.8,
  toonLink: 4.8,
  darkPit: 4.8,
  yoshi: 4.7,
  rob: 4.7,
  peach: 4.7,
  ike: 4.6,
  captainFalcon: 4.5,
  pit: 4.5,
  corrin: 4.5,
  donkeyKong: 4.5,
  mario: 4.5,
  mewTwo: 4.5,
  tactician: 4.4,
  metaKnight: 4.4,
  rosalina: 4.4,
  villager: 4.3,
  cloud: 4.3,
  greninja: 4.3,
  bowser: 4.2,
  megaMan: 4.2,
  ryu: 4.2,
  lucario: 4.1,
  pikachu: 4.1,
  marth: 4.0,
  sonic: 3.9,
  sheik: 3.9,
  zss: 3.9,
  fox: 3.8,
  bayonetta: 3.6,
  diddyKong: 3.6
});
const drMario= new Fighter(42, "Dr Mario", "drMario", drMarioImg, 5, "Cape Gimp", {
  defaultOpponent: null,
  drMario: 5.0,
  qezox: 5,
  daciex: 5.5,
  zeldark: 4.5,
  zelda: 5.7,
  kingDedede: 5.6,
  jigglypuff: 5.5,
  samus: 5.5,
  duckHunt: 5.4,
  mrGameAndWatch: 5.3,
  pacMan: 5.3,
  palutena: 5.2,
  bowserJr: 5.2,
  falco: 5.1,
  wiiFitTrainer: 5.1,
  kirby: 5.0,
  link: 5.0,
  tactician: 5.0,
  ganondorf: 4.7,
  roy: 4.7,
  ike: 4.7,
  littleMac: 4.6,
  shulk: 4.6,
  charizard: 4.6,
  peach: 4.6,
  megaMan: 4.5,
  wario: 4.5,
  pikachu: 4.5,
  luigi: 4.4,
  lucario: 4.4,
  lucas: 4.4,
  mario: 4.4,
  olimar: 4.3,
  captainFalcon: 4.3,
  yoshi: 4.3,
  metaKnight: 4.3,
  rob: 4.3,
  ness: 4.3,
  villager: 4.2,
  toonLink: 4.2,
  corrin: 4.2,
  mewTwo: 4.1,
  fox: 4.0,
  darkPit: 4.0,
  pit: 4.0,
  ryu: 4.0,
  bowser: 4.0,
  sheik: 3.9,
  greninja: 3.9,
  donkeyKong: 3.8,
  lucina: 3.8,
  zss: 3.8,
  diddyKong: 3.7,
  rosalina: 3.6,
  marth: 3.5,
  bayonetta: 3.4,
  cloud: 3.4,
  sonic: 3.3
});
const darkPit = new Fighter(43, "Dark Pit", "darkPit", darkPitImg, 1, "Side-B", {
  defaultOpponent: null,
  darkPit: 5.0,
  qezox: 5.5,
  daciex: 5.5,
  zeldark: 4.5,
  duckHunt: 6.3,
  jigglypuff: 6.2,
  charizard: 6.2,
  drMario: 6.0,
  zelda: 6.0,
  littleMac: 6.0,
  wiiFitTrainer: 5.8,
  palutena: 5.8,
  ganondorf: 5.8,
  link: 5.8,
  kirby: 5.7,
  olimar: 5.7,
  roy: 5.6,
  samus: 5.6,
  kingDedede: 5.6,
  pacMan: 5.5,
  mrGameAndWatch: 5.5,
  bowserJr: 5.5,
  ness: 5.5,
  falco: 5.4,
  lucas: 5.3,
  tactician: 5.3,
  villager: 5.2,
  megaMan: 5.2,
  shulk: 5.2,
  peach: 5.2,
  bowser: 5.2,
  wario: 5.1,
  ike: 5.1,
  luigi: 5.1,
  greninja: 5.1,
  lucina: 5.0,
  toonLink: 5.0,
  pit: 5.0,
  marth: 5.0,
  donkeyKong: 4.9,
  lucario: 4.8,
  yoshi: 4.8,
  corrin: 4.7,
  pikachu: 4.5,
  mario: 4.5,
  rob: 4.5,
  captainFalcon: 4.5,
  cloud: 4.5,
  ryu: 4.4,
  sonic: 4.4,
  zss: 4.4,
  rosalina: 4.4,
  fox: 4.4,
  sheik: 4.3,
  diddyKong: 4.3,
  metaKnight: 4.2,
  mewTwo: 4.2,
  bayonetta: 3.8
});
const lucina = new Fighter(44, "Lucina", "lucina", lucinaImg, 6, "Shield Break KO", {
  defaultOpponent: null,
  lucina: 5.0,
  luigi: 5.3,
  qezox: 6,
  daciex: 6.5,
  zeldark: 5.5,
  jigglypuff: 6.8,
  ganondorf: 6.2,
  drMario: 6.2,
  zelda: 6.2,
  kirby: 6.2,
  wiiFitTrainer: 6.0,
  bowserJr: 5.9,
  duckHunt: 5.8,
  littleMac: 5.8,
  mrGameAndWatch: 5.7,
  kingDedede: 5.7,
  wario: 5.6,
  pacMan: 5.5,
  ness: 5.5,
  link: 5.5,
  palutena: 5.5,
  falco: 5.4,
  charizard: 5.4,
  peach: 5.3,
  samus: 5.3,
  olimar: 5.2,
  roy: 5.2,
  shulk: 5.2,
  toonLink: 5.1,
  mario: 5.1,
  yoshi: 5.1,
  lucario: 5.0,
  bowser: 5.0,
  rob: 5.0,
  villager: 5.0,
  darkPit: 5.0,
  lucas: 4.9,
  ike: 4.9,
  pit: 4.9,
  ryu: 4.8,
  megaMan: 4.8,
  greninja: 4.7,
  captainFalcon: 4.7,
  fox: 4.7,
  tactician: 4.6,
  donkeyKong: 4.6,
  marth: 4.6,
  sheik: 4.5,
  metaKnight: 4.5,
  mewTwo: 4.4,
  pikachu: 4.4,
  corrin: 4.4,
  cloud: 4.4,
  rosalina: 4.3,
  diddyKong: 4.3,
  zss: 4.2,
  bayonetta: 4.0,
  sonic: 3.9
});
const pacMan= new Fighter(45, "Pac-Man", "pacMan", pacManImg, 5, "Trampoline Gimp", {
  defaultOpponent: null,
  pacMan: 5.0,
  qezox: 4.5,
  daciex: 5,
  zeldark: 4,
  ganondorf: 5.9,
  kingDedede: 5.7,
  jigglypuff: 5.6,
  littleMac: 5.4,
  mrGameAndWatch: 5.4,
  ike: 5.3,
  duckHunt: 5.2,
  charizard: 5.2,
  wiiFitTrainer: 5.1,
  donkeyKong: 5.1,
  bowserJr: 5.0,
  zelda: 5.0,
  roy: 4.9,
  kirby: 4.8,
  lucas: 4.8,
  bowser: 4.8,
  ness: 4.8,
  ryu: 4.7,
  drMario: 4.7,
  shulk: 4.7,
  megaMan: 4.7,
  tactician: 4.7,
  peach: 4.5,
  palutena: 4.5,
  darkPit: 4.5,
  pit: 4.5,
  lucina: 4.5,
  toonLink: 4.4,
  wario: 4.4,
  rob: 4.4,
  link: 4.4,
  yoshi: 4.4,
  falco: 4.4,
  captainFalcon: 4.4,
  samus: 4.3,
  luigi: 4.3,
  metaKnight: 4.3,
  greninja: 4.3,
  pikachu: 4.3,
  sheik: 4.3,
  olimar: 4.3,
  marth: 4.2,
  zss: 4.2,
  corrin: 4.1,
  villager: 4.1,
  fox: 4.0,
  diddyKong: 4.0,
  mario: 3.9,
  lucario: 3.8,
  mewTwo: 3.8,
  bayonetta: 3.7,
  sonic: 3.7,
  rosalina: 3.6,
  cloud: 3.5
});
const megaMan = new Fighter(46, "Mega Man", "megaMan", megaManImg, 10, "Shoryuken", {
  defaultOpponent: null,
  megaMan: 5.0,
  qezox: 5.5,
  daciex: 6,
  zeldark: 4.5,
  kingDedede: 6.5,
  ganondorf: 6.3,
  roy: 6.2,
  jigglypuff: 6.2,
  donkeyKong: 6.1,
  zelda: 6.0,
  charizard: 6.0,
  ike: 6.0,
  olimar: 5.9,
  luigi: 5.9,
  tactician: 5.8,
  mrGameAndWatch: 5.8,
  bowser: 5.8,
  wiiFitTrainer: 5.8,
  shulk: 5.8,
  bowserJr: 5.8,
  captainFalcon: 5.7,
  duckHunt: 5.6,
  littleMac: 5.6,
  drMario: 5.5,
  samus: 5.5,
  kirby: 5.5,
  ness: 5.5,
  ryu: 5.5,
  wario: 5.4,
  falco: 5.4,
  palutena: 5.4,
  toonLink: 5.4,
  link: 5.4,
  yoshi: 5.3,
  pacMan: 5.3,
  peach: 5.3,
  pit: 5.3,
  lucina: 5.2,
  marth: 5.2,
  sonic: 5.2,
  lucas: 5.1,
  villager: 5.0,
  greninja: 5.0,
  diddyKong: 5.0,
  rob: 5.0,
  pikachu: 4.9,
  corrin: 4.8,
  darkPit: 4.8,
  cloud: 4.7,
  metaKnight: 4.7,
  lucario: 4.6,
  zss: 4.5,
  bayonetta: 4.3,
  sheik: 4.2,
  mario: 4.1,
  rosalina: 4.0,
  mewTwo: 4.0,
  fox: 3.6
});
const sonic = new Fighter(47, "Sonic", "sonic", sonicImg, 6, "Spring Gimp", {
  defaultOpponent: null,
  sonic: 5.0,
  qezox: 6,
  daciex: 6.5,
  zeldark: 5,
  jigglypuff: 7.2,
  kingDedede: 7.1,
  kirby: 7.1,
  ganondorf: 7.1,
  charizard: 7.0,
  palutena: 6.9,
  zelda: 6.8,
  drMario: 6.7,
  bowser: 6.5,
  duckHunt: 6.3,
  mrGameAndWatch: 6.3,
  ike: 6.3,
  wiiFitTrainer: 6.3,
  pacMan: 6.3,
  donkeyKong: 6.3,
  link: 6.2,
  falco: 6.1,
  littleMac: 6.1,
  peach: 6.1,
  lucina: 6.1,
  shulk: 6.1,
  rob: 6.1,
  bowserJr: 6.0,
  samus: 6.0,
  pit: 6.0,
  roy: 6.0,
  marth: 6.0,
  olimar: 5.9,
  greninja: 5.9,
  luigi: 5.8,
  ness: 5.8,
  ryu: 5.8,
  tactician: 5.8,
  lucas: 5.7,
  wario: 5.7,
  yoshi: 5.6,
  metaKnight: 5.6,
  darkPit: 5.6,
  toonLink: 5.5,
  villager: 5.5,
  pikachu: 5.4,
  mario: 5.4,
  captainFalcon: 5.3,
  corrin: 5.2,
  lucario: 5.2,
  rosalina: 5.1,
  mewTwo: 5.1,
  bayonetta: 5.1,
  zss: 5.0,
  sheik: 5.0,
  megaMan: 4.8,
  diddyKong: 4.8,
  cloud: 4.7,
  fox: 4.6
});
const mewTwo = new Fighter(48, "MewTwo", "mewTwo", mewTwoImg, 6, "Disable KO", {
  defaultOpponent: null,
  mewTwo: 5.0,
  qezox: 5,
  daciex: 5.5,
  zeldark: 5,
  jigglypuff: 6.8,
  duckHunt: 6.6,
  bowserJr: 6.5,
  zelda: 6.4,
  palutena: 6.3,
  kingDedede: 6.2,
  pacMan: 6.2,
  tactician: 6.2,
  falco: 6.1,
  wiiFitTrainer: 6.1,
  samus: 6.1,
  kirby: 6.1,
  ganondorf: 6.1,
  charizard: 6.1,
  luigi: 6.0,
  rob: 6.0,
  megaMan: 6.0,
  link: 5.9,
  mrGameAndWatch: 5.9,
  olimar: 5.9,
  drMario: 5.9,
  bowser: 5.8,
  darkPit: 5.8,
  wario: 5.8,
  ike: 5.7,
  villager: 5.6,
  donkeyKong: 5.6,
  toonLink: 5.6,
  lucina: 5.6,
  ness: 5.5,
  shulk: 5.5,
  roy: 5.5,
  captainFalcon: 5.5,
  lucas: 5.5,
  pit: 5.5,
  littleMac: 5.5,
  lucario: 5.4,
  peach: 5.4,
  greninja: 5.4,
  yoshi: 5.3,
  pikachu: 5.2,
  rosalina: 5.2,
  ryu: 5.2,
  metaKnight: 5.1,
  corrin: 5.1,
  marth: 5.1,
  bayonetta: 5.0,
  fox: 5.0,
  sonic: 4.9,
  zss: 4.9,
  mario: 4.9,
  sheik: 4.7,
  cloud: 4.5,
  diddyKong: 4.4
});
const lucas = new Fighter(49, "Lucas", "lucas", lucasImg, 5, "PK Ice Gimp", {
  defaultOpponent: null,
  lucas: 5.0,
  qezox: 5,
  daciex: 5.5,
  zeldark: 4.5,
  littleMac: 6.0,
  ganondorf: 6.0,
  wiiFitTrainer: 6.0,
  bowserJr: 5.9,
  jigglypuff: 5.8,
  charizard: 5.8,
  kingDedede: 5.7,
  samus: 5.7,
  drMario: 5.6,
  palutena: 5.6,
  falco: 5.6,
  zelda: 5.6,
  duckHunt: 5.5,
  pacMan: 5.2,
  link: 5.2,
  bowser: 5.2,
  kirby: 5.2,
  mrGameAndWatch: 5.1,
  donkeyKong: 5.1,
  luigi: 5.1,
  ness: 5.1,
  tactician: 5.1,
  rob: 5.1,
  wario: 5.1,
  lucina: 5.1,
  toonLink: 5.0,
  peach: 5.0,
  roy: 5.0,
  megaMan: 4.9,
  pikachu: 4.9,
  ike: 4.8,
  villager: 4.8,
  pit: 4.8,
  yoshi: 4.7,
  captainFalcon: 4.7,
  darkPit: 4.7,
  ryu: 4.7,
  metaKnight: 4.6,
  corrin: 4.6,
  lucario: 4.6,
  zss: 4.5,
  mewTwo: 4.5,
  shulk: 4.5,
  greninja: 4.5,
  olimar: 4.5,
  fox: 4.4,
  marth: 4.4,
  mario: 4.4,
  bayonetta: 4.4,
  sonic: 4.3,
  diddyKong: 4.2,
  rosalina: 4.2,
  cloud: 4.1,
  sheik: 4.1
});
const roy = new Fighter(50, "Roy", "roy", royImg, 5, "Counter Return Gimp", {
  defaultOpponent: null,
  roy: 5.0,
  qezox: 4.5,
  daciex: 5,
  zeldark: 4.5,
  jigglypuff: 6.4,
  bowserJr: 5.8,
  ganondorf: 5.7,
  kingDedede: 5.6,
  zelda: 5.5,
  charizard: 5.5,
  falco: 5.5,
  kirby: 5.4,
  drMario: 5.3,
  littleMac: 5.3,
  mrGameAndWatch: 5.2,
  duckHunt: 5.1,
  link: 5.2,
  palutena: 5.1,
  wario: 5.1,
  pacMan: 5.1,
  lucas: 5.0,
  wiiFitTrainer: 5.0,
  peach: 4.9,
  samus: 4.9,
  shulk: 4.8,
  yoshi: 4.8,
  lucina: 4.8,
  toonLink: 4.7,
  ike: 4.7,
  rob: 4.6,
  luigi: 4.5,
  pit: 4.5,
  donkeyKong: 4.5,
  mewTwo: 4.5,
  darkPit: 4.4,
  captainFalcon: 4.4,
  tactician: 4.3,
  mario: 4.3,
  villager: 4.3,
  ness: 4.3,
  ryu: 4.3,
  greninja: 4.2,
  corrin: 4.2,
  bowser: 4.2,
  lucario: 4.1,
  marth: 4.0,
  cloud: 4.0,
  sonic: 4.0,
  metaKnight: 4.0,
  zss: 3.9,
  olimar: 3.9,
  fox: 3.8,
  pikachu: 3.8,
  megaMan: 3.8,
  sheik: 3.7,
  diddyKong: 3.7,
  rosalina: 3.6,
  bayonetta: 3.4
});
const ryu = new Fighter(51, "Ryu", "ryu", ryuImg, 8, "Shoryuken", {
  defaultOpponent: null,
  ryu: 5.0,
  qezox: 6.3,
  daciex: 6,
  zeldark: 5,
  jigglypuff: 7.0,
  ganondorf: 6.7,
  zelda: 6.6,
  charizard: 6.1,
  palutena: 6.1,
  bowser: 6.1,
  kingDedede: 6.1,
  bowserJr: 6.0,
  drMario: 6.0,
  littleMac: 6.0,
  donkeyKong: 6.0,
  link: 5.9,
  kirby: 5.9,
  shulk: 5.8,
  roy: 5.7,
  wiiFitTrainer: 5.7,
  peach: 5.7,
  wario: 5.6,
  captainFalcon: 5.6,
  lucario: 5.6,
  darkPit: 5.6,
  ike: 5.6,
  tactician: 5.5,
  fox: 5.5,
  falco: 5.5,
  pit: 5.4,
  luigi: 5.4,
  samus: 5.4,
  lucas: 5.3,
  duckHunt: 5.3,
  pacMan: 5.3,
  yoshi: 5.3,
  rob: 5.3,
  ness: 5.2,
  greninja: 5.2,
  lucina: 5.2,
  metaKnight: 5.2,
  toonLink: 5.2,
  mario: 5.1,
  pikachu: 5.1,
  corrin: 5.1,
  zss: 5.1,
  olimar: 5.0,
  marth: 5.0,
  villager: 4.9,
  mewTwo: 4.8,
  sheik: 4.8,
  rosalina: 4.7,
  cloud: 4.6,
  megaMan: 4.5,
  diddyKong: 4.5,
  bayonetta: 4.5,
  sonic: 4.2,
  mrGameAndWatch: 6.2,
});
const cloud = new Fighter(52, "Cloud", "cloud", cloudImg, 3, "Down-B", {
  defaultOpponent: null,
  cloud: 5.0,
  qezox: 5.5,
  daciex: 6,
  zeldark: 5.5,
  kingDedede: 7.1,
  jigglypuff: 7.1,
  ganondorf: 7.0,
  zelda: 6.9,
  littleMac: 6.9,
  duckHunt: 6.6,
  drMario: 6.6,
  wiiFitTrainer: 6.6,
  pacMan: 6.5,
  bowserJr: 6.4,
  wario: 6.3,
  kirby: 6.2,
  palutena: 6.2,
  mrGameAndWatch: 6.2,
  charizard: 6.2,
  falco: 6.2,
  tactician: 6.1,
  bowser: 6.1,
  donkeyKong: 6.0,
  megaMan: 5.3,
  yoshi: 6.0,
  samus: 6.0,
  peach: 6.0,
  olimar: 6.0,
  rob: 6.0,
  villager: 6.0,
  ness: 6.0,
  link: 6.0,
  roy: 6.0,
  toonLink: 5.9,
  ike: 5.9,
  luigi: 5.8,
  captainFalcon: 5.8,
  lucario: 5.8,
  shulk: 5.7,
  lucina: 5.6,
  greninja: 5.6,
  pit: 5.6,
  corrin: 5.6,
  darkPit: 5.5,
  zss: 5.5,
  mewTwo: 5.5,
  rosalina: 5.4,
  marth: 5.4,
  ryu: 5.4,
  mario: 5.4,
  fox: 5.3,
  sonic: 5.3,
  metaKnight: 5.3,
  lucas: 5.9,
  pikachu: 5.0,
  diddyKong: 4.8,
  bayonetta: 4.7,
  sheik: 4.5
});
const corrin = new Fighter(53, "Corrin", "corrin", corrinImg, 5, "Down-Air Spike", {
  defaultOpponent: null,
  corrin: 5.0,
  qezox: 5,
  daciex: 6,
  zeldark: 6,
  jigglypuff: 6.8,
  zelda: 6.5,
  ganondorf: 6.4,
  kingDedede: 6.3,
  littleMac: 6.1,
  kirby: 6.1,
  charizard: 6.0,
  wario: 6.0,
  palutena: 6.0,
  duckHunt: 6.0,
  bowserJr: 5.9,
  bowser: 5.9,
  pacMan: 5.9,
  donkeyKong: 5.9,
  roy: 5.8,
  mrGameAndWatch: 5.8,
  tactician: 5.8,
  drMario: 5.8,
  samus: 5.8,
  wiiFitTrainer: 5.7,
  ike: 5.7,
  ness: 5.7,
  luigi: 5.7,
  lucina: 5.6,
  rob: 5.6,
  falco: 5.5,
  yoshi: 5.5,
  link: 5.5,
  shulk: 5.5,
  olimar: 5.4,
  greninja: 5.4,
  lucas: 5.4,
  pit: 5.3,
  captainFalcon: 5.3,
  peach: 5.3,
  darkPit: 5.3,
  lucario: 5.3,
  rosalina: 5.2,
  villager: 5.2,
  megaMan: 5.2,
  toonLink: 5.1,
  marth: 5.0,
  metaKnight: 5.0,
  mario: 4.9,
  ryu: 4.9,
  mewTwo: 4.9,
  sonic: 4.8,
  pikachu: 4.7,
  zss: 4.7,
  fox: 4.6,
  diddyKong: 4.5,
  sheik: 4.5,
  cloud: 4.4,
  bayonetta: 4.4
});
const bayonetta = new Fighter(54, "Bayonetta", "bayonetta", bayonettaImg, 4, "Full Combo", {
  defaultOpponent: null,
  bayonetta: 5.0,
  qezox: 6.5,
  daciex: 6.5,
  zeldark: 6,
  kingDedede: 7.7,
  ganondorf: 7.6,
  zelda: 7.0,
  charizard: 7.0,
  jigglypuff: 6.9,
  bowserJr: 6.8,
  littleMac: 6.7,
  drMario: 6.6,
  roy: 6.6,
  tactician: 6.6,
  falco: 6.5,
  link: 6.5,
  duckHunt: 6.5,
  bowser: 6.4,
  mrGameAndWatch: 6.4,
  wiiFitTrainer: 6.4,
  shulk: 6.4,
  kirby: 6.4,
  wario: 6.4,
  samus: 6.4,
  pacMan: 6.3,
  donkeyKong: 6.2,
  yoshi: 6.2,
  darkPit: 6.2,
  palutena: 6.1,
  captainFalcon: 6.1,
  ike: 6.1,
  pit: 6.1,
  lucina: 6.0,
  luigi: 6.0,
  olimar: 5.9,
  rob: 5.9,
  peach: 5.8,
  zss: 5.7,
  lucario: 5.7,
  megaMan: 5.7,
  lucas: 5.6,
  corrin: 5.6,
  ryu: 5.5,
  metaKnight: 5.5,
  ness: 5.5,
  marth: 5.4,
  villager: 5.4,
  greninja: 5.4,
  toonLink: 5.3,
  rosalina: 5.3,
  fox: 5.3,
  cloud: 5.3,
  pikachu: 5.2,
  mewTwo: 5.0,
  mario: 5.0,
  sonic: 4.9,
  diddyKong: 4.7,
  sheik: 4.5
});
const qezox = new Fighter(55, "Qezox", "qezox", qezoxImg, 7, "Charge-Shot", {
  defaultOpponent: null,
  duckHunt: 5,
  qezox: 5,
  mario: 4,
  luigi: 4,
  peach: 5.5,
  bowser: 6.5,
  yoshi: 4,
  rosalina: 3.5,
  bowserJr: 6.5,
  wario: 6,
  donkeyKong: 6.5,
  diddyKong: 4,
  mrGameAndWatch: 4,
  littleMac: 6,
  link: 5,
  zelda: 5,
  sheik: 4,
  ganondorf: 6,
  toonLink: 5,
  samus: 6,
  zss: 3.5,
  pit: 4,
  palutena: 6,
  marth: 4.5,
  ike: 6,
  tactician: 5,
  kirby: 5,
  kingDedede: 6,
  metaKnight: 5,
  fox: 4,
  falco: 5,
  pikachu: 4.7,
  charizard: 4.5,
  lucario: 5,
  jigglypuff: 6,
  greninja: 5.5,
  rob: 6,
  ness: 4,
  captainFalcon: 5.5,
  villager: 4,
  olimar: 6,
  wiiFitTrainer: 5,
  shulk: 5.5,
  drMario: 5,
  darkPit: 4.5,
  lucina: 4,
  pacMan: 5.5,
  megaMan: 4.5,
  sonic: 4,
  mewTwo: 5,
  lucas: 5,
  roy: 5.5,
  ryu: 4.7,
  cloud: 4.5,
  corrin: 5,
  bayonetta: 3.5,
  daciex: 6,
  zeldark: 4.5
});
const daciex = new Fighter(56, "Daciex", "daciex", daciexImg, 7,"Super-Punch", {
  defaultOpponent: null,
  daciex: 5,
  duckHunt: 4.5,
  mario: 3.4,
  luigi: 4,
  peach: 5,
  bowser: 4,
  yoshi: 3.5,
  rosalina: 4,
  bowserJr: 5,
  wario: 5.5,
  donkeyKong: 4,
  diddyKong: 3.5,
  mrGameAndWatch: 4,
  littleMac: 4,
  link: 4,
  zelda: 5,
  sheik: 4.5,
  ganondorf: 5,
  toonLink: 4,
  samus: 4,
  zss: 4,
  pit: 4,
  palutena: 6,
  marth: 3.7,
  ike: 4,
  tactician: 4.4,
  kirby: 5,
  kingDedede: 5,
  metaKnight: 4,
  fox: 4.5,
  falco: 5,
  pikachu: 4.4,
  charizard: 4,
  lucario: 5,
  jigglypuff: 4.5,
  greninja: 5.5,
  rob: 4,
  ness: 3.5,
  captainFalcon: 5,
  villager: 3.5,
  olimar: 5,
  wiiFitTrainer: 5,
  shulk: 4,
  drMario: 4.5,
  darkPit: 4.5,
  lucina: 3.5,
  pacMan: 5,
  megaMan: 4,
  sonic: 3.5,
  mewTwo: 4.5,
  lucas: 4.5,
  roy: 5,
  ryu: 4,
  cloud: 4,
  corrin: 4,
  bayonetta: 3.5,
  qezox: 4,
  zeldark: 4
});
const zeldark = new Fighter(57, "Zeldark", "zeldark", zeldarkImg, 7, "Counter KO", {
  defaultOpponent: null,
  zeldark: 5,
  duckHunt: 5,
  mario: 4.5,
  luigi: 5,
  peach: 6,
  bowser: 6.5,
  yoshi: 5,
  rosalina: 4.5,
  bowserJr: 6,
  wario: 6,
  donkeyKong: 5.5,
  diddyKong: 4.5,
  mrGameAndWatch: 5.5,
  littleMac: 5.5,
  link: 5,
  zelda: 5.5,
  sheik: 5,
  ganondorf: 5.5,
  toonLink: 5,
  samus: 5,
  zss: 5,
  pit: 4.5,
  palutena: 6,
  marth: 4.8,
  ike: 5,
  tactician: 5,
  kirby: 5.5,
  kingDedede: 5.5,
  metaKnight: 5.5,
  fox: 5.5,
  falco: 5.5,
  pikachu: 5.1,
  charizard: 5,
  lucario: 5.5,
  jigglypuff: 5.5,
  greninja: 6,
  rob: 4.8,
  ness: 4.5,
  captainFalcon: 5.5,
  villager: 4,
  olimar: 5.5,
  wiiFitTrainer: 5.5,
  shulk: 5.5,
  drMario: 5.5,
  darkPit: 5.5,
  lucina: 4.5,
  pacMan: 6,
  megaMan: 5.5,
  sonic: 5,
  mewTwo: 5,
  lucas: 5.5,
  roy: 5.5,
  ryu: 5,
  cloud: 4.5,
  corrin: 4,
  bayonetta: 4,
  qezox: 5.5,
  daciex: 6
});
const defaultSelection = new Fighter(58, "Default Selection", "defaultSelection", randomImg, 0, "", {});
const defaultOpponent = new Fighter(59, "Default Opponent", "defaultOpponent", defaultImg, 0, "", {});
const Roster = {
  fighters: {
    all: [mario, luigi, peach, bowser, yoshi, rosalina, bowserJr, wario, donkeyKong, diddyKong, mrGameAndWatch, littleMac,
          link, zelda, sheik, ganondorf, toonLink, samus, zss, pit, palutena, marth, ike, tactician,
          duckHunt, kirby, kingDedede, metaKnight, fox, falco, pikachu, charizard, lucario, jigglypuff, greninja,
          rob, ness, captainFalcon, villager, olimar, wiiFitTrainer, shulk, drMario, darkPit, lucina, pacMan,
          megaMan, sonic, mewTwo, lucas, roy, ryu, cloud, corrin, bayonetta, qezox, daciex, zeldark],
    row1: [mario, luigi, peach, bowser, yoshi, rosalina, bowserJr, wario, donkeyKong, diddyKong, mrGameAndWatch, littleMac],
    row2: [link, zelda, sheik, ganondorf, toonLink, samus, zss, pit, palutena, marth, ike, tactician],
    row3: [duckHunt, kirby, kingDedede, metaKnight, fox, falco, pikachu, charizard, lucario, jigglypuff, greninja],
    row4: [rob, ness, captainFalcon, villager, olimar, wiiFitTrainer, shulk, drMario, darkPit, lucina, pacMan],
    row5: [megaMan, sonic, mewTwo, lucas, roy, ryu, cloud, corrin, bayonetta, qezox, daciex, zeldark],
    selected: defaultSelection,
    opponent: defaultOpponent,
    counters: [],
    defaultSelection: defaultSelection,
    defaultOpponent: defaultOpponent
  },
  mario: mario,
  luigi: luigi,
  peach: peach,
  bowser: bowser,
  yoshi: yoshi,
  rosalina: rosalina,
  bowserJr: bowserJr,
  wario: wario,
  donkeyKong: donkeyKong,
  diddyKong: diddyKong,
  mrGameAndWatch: mrGameAndWatch,
  littleMac: littleMac,
  link: link,
  zelda: zelda,
  sheik: sheik,
  ganondorf: ganondorf,
  toonLink: toonLink,
  samus: samus,
  zss: zss,
  pit: pit,
  palutena: palutena,
  marth: marth,
  ike: ike,
  tactician: tactician,
  duckHunt: duckHunt,
  kirby: kirby,
  kingDedede: kingDedede,
  metaKnight: metaKnight,
  fox: fox,
  falco: falco,
  pikachu: pikachu,
  charizard: charizard,
  lucario: lucario,
  jigglypuff: jigglypuff,
  greninja: greninja,
  rob: rob,
  ness: ness,
  captainFalcon: captainFalcon,
  villager: villager,
  olimar: olimar,
  wiiFitTrainer: wiiFitTrainer,
  shulk: shulk,
  drMario: drMario,
  darkPit: darkPit,
  lucina: lucina,
  pacMan: pacMan,
  megaMan: megaMan,
  sonic: sonic,
  mewTwo: mewTwo,
  lucas: lucas,
  roy: roy,
  ryu: ryu,
  cloud: cloud,
  corrin: corrin,
  bayonetta: bayonetta,
  zeldark: zeldark,
  daciex: daciex,
  qezox: qezox,
  defaultSelection: defaultSelection,
  defaultOpponent: defaultOpponent,
  mode: "favoredRandom",
  maxMetric: 10,
  djangoMetrics: {},

  setMode(mode) {
    this.mode = mode;
  },

  setOpponent(fighter) {
    this.fighters.opponent = fighter;
  },

  updatePlayMetrics(opponentKeyName, mode) {
    for (let i=0; i<this.fighters.all.length; i++) {
      this.fighters.all[i].updatePlayMetric(opponentKeyName, mode);
    }
  },

  findPlayMetricTotal() {
    let playMetricTotal = 0;
    for (let i=0; i<this.fighters.all.length; i++) {
      playMetricTotal += this.fighters.all[i].playMetric;
    }
    return playMetricTotal;
  },

  findMaxMetric() {
    let max = 0;
    for (let i=0; i<this.fighters.all.length; i++) {
      if (this.fighters.all[i].playMetric > max) {
        max = this.fighters.all[i].playMetric;
      }
    }
    this.maxMetric = max;
    this.djangoMetrics.maxMetric = this.maxMetric;
  },

  randomizeFighter(opponentKeyName, mode) {
    this.updatePlayMetrics(opponentKeyName, mode);
    let randomNumber = Math.random() * this.findPlayMetricTotal();
    let runningMetric = 0;
    let selected;
    let i=0;
    while (runningMetric < randomNumber) {
      selected = this.fighters.all[i];
      runningMetric += this.fighters.all[i].playMetric;
      i++;
    }
    this.fighters.selected = selected;
    for (let i=0; i<this.fighters.all.length; i++) {
      this.fighters.all[i].favorUp();
    }
    this.fighters.selected.resetFavor();
  },

  findCounterArray(fighter) {
    this.fighters.counters = [];
    if (this.fighters.opponent !== this.fighters.defaultOpponent) {
      let tempArray = this.fighters.all.slice(0);
      for (let i=0; i<12; i++) {
        let counterPick;
        let counterRating = 0;
        for (let j=0; j<tempArray.length; j++) {
          if (tempArray[j].matchups[fighter] > counterRating) {
            counterPick = tempArray[j];
            counterRating = tempArray[j].matchups[fighter];
          }
        }
        this.fighters.counters.push(counterPick);
        tempArray.splice(tempArray.indexOf(counterPick), 1);
      }
    }
  }
};

export default Roster;



// WEBPACK FOOTER //
// ./src/util/Roster.js